var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-preferences",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-preferences:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-127",
    className: "animable",
    style: {
      transformOrigin: "249.81px 348.83px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-127",
    cx: 249.81,
    cy: 348.83,
    rx: 231.54,
    ry: 133.68,
    style: {
      fill: "#f0f0f0",
      transformOrigin: "249.81px 348.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-127",
    className: "animable",
    style: {
      transformOrigin: "251.409px 379.312px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-127",
    d: "m156.7 430.37-8.68-5.1a5.42 5.42 0 0 0-4.9 0L129.66 433a5.4 5.4 0 0 1-4.89 0l-45.6-26.32c-1.35-.78-1.35-2.05 0-2.83l151.16-87.28a5.42 5.42 0 0 1 4.9 0l45.59 26.33c1.36.78 1.36 2.05 0 2.85l-13.49 7.92c-1.35.79-1.34 2.06 0 2.83l8.66 4.94c1.35.77 1.36 2 0 2.81l-114.4 66.12a5.4 5.4 0 0 1-4.89 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "179.999px 374.785px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-127",
    cx: 359.67,
    cy: 405.12,
    rx: 64.99,
    ry: 37.52,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "359.67px 405.12px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-127",
    className: "animable",
    style: {
      transformOrigin: "97.5292px 357.985px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-127",
    className: "animable",
    style: {
      transformOrigin: "97.5292px 357.985px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.43 365.34s1.64-18.47-4.43-34.34-16.65-27.13-28-30.4-22.7 5.4-11.89 15.22 31.12 21.72 35.62 51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "97.1931px 333.359px"
    },
    id: "elbxykhton0ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43 365.34s1.64-18.47-4.43-34.34-16.65-27.13-28-30.4-22.7 5.4-11.89 15.22 31.12 21.72 35.62 51Z",
    style: {
      opacity: 0.15,
      transformOrigin: "97.1931px 333.359px"
    },
    className: "animable",
    id: "elbqsv3ikljqw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 360h.13a.63.63 0 0 0 .5-.73c-6-32.42-26.54-49.66-36.55-54.25a.63.63 0 1 0-.52 1.14c9.81 4.49 29.92 21.43 35.84 53.34a.61.61 0 0 0 .6.5Z",
    style: {
      fill: "#fff",
      transformOrigin: "100.885px 332.466px"
    },
    id: "elob2314bnqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41 395.42v-2.78a30.68 30.68 0 0 1 1.07-7.69c.71-2.45 2.38-4.41 3-6.84s-.42-5.77-1.9-7.85-3.77-3.89-4.6-6.4c-1-3.15.92-6.32.07-9.23s-4.06-4.71-6.7-5.42c-3.52-1-7.27-.71-10.82-1.54-4.6-1.08-8.57-3.88-12.74-6.1s-9-3.92-13.56-2.57a10.94 10.94 0 0 0-7 14.68c1 2.45 2.87 4.44 4.23 6.71s2.1 4.89 1.07 7.37c-.76 1.84-2.13 3.24-2.76 5.15-1.63 4.91-.72 9.32 4.17 11.83 5.11 2.62 13.17.65 15.7 7.07 1 2.45 1 5.14 1.51 7.71a20.73 20.73 0 0 0 8.42 12.78c4.68 3.25 12 5.16 17.41 2.55 4.36-2.12 3.47-5.53 3.61-9.82.08-3.21-.13-6.41-.18-9.61Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "97.5292px 377.296px"
    },
    id: "elu02fzydjxy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 373.84a.61.61 0 0 0 .35 0c.12-.06 12.39-5.73 26.6 1.92a.59.59 0 0 0 .8-.24.58.58 0 0 0-.24-.8c-14.76-7.94-27.54-2-27.67-1.95a.6.6 0 0 0-.28.79.61.61 0 0 0 .44.28Z",
    style: {
      fill: "#fff",
      transformOrigin: "98.6646px 373.21px"
    },
    id: "el5gek5x2iibp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23 405.11a.55.55 0 0 1-.56-.53c-1-24.73-25.85-50.89-42.49-58a.55.55 0 1 1 .43-1c16.91 7.25 42.13 33.84 43.16 59a.55.55 0 0 1-.53.58Z",
    style: {
      fill: "#fff",
      transformOrigin: "101.772px 375.329px"
    },
    id: "elll9s1jmhwnh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-127",
    className: "animable",
    style: {
      transformOrigin: "111.298px 146.846px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-127",
    className: "animable",
    style: {
      transformOrigin: "111.298px 146.846px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m158 87.45-7.68-4.4a.88.88 0 0 0-.79 0l-9.07 4.09a1.08 1.08 0 0 1-1.51-.7c-.52-1.67 1.45-1.67.63-3a2.48 2.48 0 0 1-.14-2.19l6-12.19a1.38 1.38 0 0 0-.44-1.76l-9.24-5.3a1.36 1.36 0 0 0-1.8.42l-7.54 11.33a2.49 2.49 0 0 1-2 1 19.66 19.66 0 0 0-2.63.12l2.65-6.78-7.69-4.4a.82.82 0 0 0-.82.07l-10.19 5.88a2.78 2.78 0 0 0-1.22 1.91l-1 11.34a3.74 3.74 0 0 1-1.05 2.11 62.06 62.06 0 0 0-5.66 6 1.94 1.94 0 0 1-2 .57l-6.54-2.28a1.6 1.6 0 0 0-1.84.68l-7.49 13a1.59 1.59 0 0 0 .33 1.93l5.25 4.52a2 2 0 0 1 .51 2 60.24 60.24 0 0 0-2.36 7.9 3.79 3.79 0 0 1-1.31 2l-9.31 6.56a2.75 2.75 0 0 0-1 2v11.72a.81.81 0 0 0 .37.75l7.67 4.4 4.81-5a16.67 16.67 0 0 0 .93 1.73 2.51 2.51 0 0 1 .13 2.2l-6 12.19a1.39 1.39 0 0 0 .53 1.78l9.22 5.29a1.37 1.37 0 0 0 1.8-.42l4.89-12.84a2.5 2.5 0 0 1 2-1 20.1 20.1 0 0 0 4.9-.5 1.08 1.08 0 0 1 1.37 1l1 9.9a.85.85 0 0 0 .39.7l7.66 4.4 6-8.84a2.8 2.8 0 0 0 1.22-1.91l-1.64-12.84a2.29 2.29 0 0 1 1.31-1.72 23.91 23.91 0 0 0 7.91-5.55 2 2 0 0 1 2-.54l4 1.41a1.59 1.59 0 0 0 1.84-.68l7.49-13a1.6 1.6 0 0 0-.33-1.93l-3.45-3a2.11 2.11 0 0 1-.56-2 34.19 34.19 0 0 0 .94-9.41 2.58 2.58 0 0 1 1-2l12-5a2.72 2.72 0 0 0 1-2l4.45-5.33Zm-44.51 46.64c-9.5 5.49-15.41 1.6-15.41-9.38s7.85-24.43 17.36-29.92 15.27-1.5 15.27 9.48-7.71 24.33-17.2 29.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "114.524px 114.001px"
    },
    id: "elbi9nj7z4a4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158 87.45-7.68-4.4a.88.88 0 0 0-.79 0l-9.07 4.09a1.08 1.08 0 0 1-1.51-.7c-.52-1.67 1.45-1.67.63-3a2.48 2.48 0 0 1-.14-2.19l6-12.19a1.38 1.38 0 0 0-.44-1.76l-9.24-5.3a1.36 1.36 0 0 0-1.8.42l-7.54 11.33a2.49 2.49 0 0 1-2 1 19.66 19.66 0 0 0-2.63.12l2.65-6.78-7.69-4.4a.82.82 0 0 0-.82.07l-10.19 5.88a2.78 2.78 0 0 0-1.22 1.91l-1 11.34a3.74 3.74 0 0 1-1.05 2.11 62.06 62.06 0 0 0-5.66 6 1.94 1.94 0 0 1-2 .57l-6.54-2.28a1.6 1.6 0 0 0-1.84.68l-7.49 13a1.59 1.59 0 0 0 .33 1.93l5.25 4.52a2 2 0 0 1 .51 2 60.24 60.24 0 0 0-2.36 7.9 3.79 3.79 0 0 1-1.31 2l-9.31 6.56a2.75 2.75 0 0 0-1 2v11.72a.81.81 0 0 0 .37.75l7.67 4.4 4.81-5a16.67 16.67 0 0 0 .93 1.73 2.51 2.51 0 0 1 .13 2.2l-6 12.19a1.39 1.39 0 0 0 .53 1.78l9.22 5.29a1.37 1.37 0 0 0 1.8-.42l4.89-12.84a2.5 2.5 0 0 1 2-1 20.1 20.1 0 0 0 4.9-.5 1.08 1.08 0 0 1 1.37 1l1 9.9a.85.85 0 0 0 .39.7l7.66 4.4 6-8.84a2.8 2.8 0 0 0 1.22-1.91l-1.64-12.84a2.29 2.29 0 0 1 1.31-1.72 23.91 23.91 0 0 0 7.91-5.55 2 2 0 0 1 2-.54l4 1.41a1.59 1.59 0 0 0 1.84-.68l7.49-13a1.6 1.6 0 0 0-.33-1.93l-3.45-3a2.11 2.11 0 0 1-.56-2 34.19 34.19 0 0 0 .94-9.41 2.58 2.58 0 0 1 1-2l12-5a2.72 2.72 0 0 0 1-2l4.45-5.33Zm-44.51 46.64c-9.5 5.49-15.41 1.6-15.41-9.38s7.85-24.43 17.36-29.92 15.27-1.5 15.27 9.48-7.71 24.33-17.2 29.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "114.524px 114.001px"
    },
    className: "animable",
    id: "elec0f7dafqie"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.16 148.9-14.85-6.22-12.67-6.53-5.35 9.54 2.56-4a16.67 16.67 0 0 0 .93 1.73 2.51 2.51 0 0 1 .13 2.2l-6 12.19a1.39 1.39 0 0 0 .53 1.78l9.22 5.29a1.37 1.37 0 0 0 1.8-.42l4.89-12.84a2.5 2.5 0 0 1 2-1 20.1 20.1 0 0 0 4.9-.5 1.08 1.08 0 0 1 1.37 1l1 9.9a.85.85 0 0 0 .39.7l7.66 4.4 2.84-4.18Z",
    style: {
      opacity: 0.1,
      transformOrigin: "97.1432px 151.135px"
    },
    className: "animable",
    id: "el8ddaj5tpnfi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85 112.89V93.2l-8.32-7-3.92 6.65c3.29 1.3 5.12 5.27 5.12 11.45 0 11-7.71 24.33-17.22 29.82-5.57 3.22-9.89 3.19-12.53.42l-2.85 4.82s14 4.32 20.4 1.63 19.32-28.1 19.32-28.1Z",
    style: {
      opacity: 0.1,
      transformOrigin: "117.99px 114.036px"
    },
    className: "animable",
    id: "el56dpj82ru8o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.51 73.11 2-4a1.38 1.38 0 0 0-.51-1.81l-9.24-5.3a1.36 1.36 0 0 0-1.8.42l-7.54 11.33a1.91 1.91 0 0 1-.5.48L137 80.62Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "135.791px 71.2208px"
    },
    id: "elk8ndeetx9op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.08 120.51a3.1 3.1 0 0 1-.72.76l-9.31 6.56a2.34 2.34 0 0 0-.61.7l8.33 4.79 12.36-7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "81.785px 126.915px"
    },
    id: "elsp5io4gh1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74 89.19a1.62 1.62 0 0 0-1.31.76l-7.49 13a1.53 1.53 0 0 0-.17.94l9.11 5.24 10.25-13.9Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "88.4427px 99.16px"
    },
    id: "elcysn5io6q07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75 70.86 115.39 77l9.08-5.24v-3.68l-7.69-4.4a.82.82 0 0 0-.82.07l-10.19 5.88a2.77 2.77 0 0 0-1.02 1.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "114.61px 70.3009px"
    },
    id: "eldm0f1vj079w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 87.45a.85.85 0 0 0-.81 0l-9.07 4.09a1.08 1.08 0 0 1-1.51-.7c-.35-1.14-2.52-4.2-2.32-5.42l5.24-2.37a.87.87 0 0 1 .79 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "151.139px 87.3003px"
    },
    id: "elyt13qzc218",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "114.625px 97.5954px"
    },
    className: "animable",
    id: "el5kiz95rz1se"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.51 73.11 2-4a1.38 1.38 0 0 0-.51-1.81l-9.24-5.3a1.36 1.36 0 0 0-1.8.42l-7.54 11.33a1.91 1.91 0 0 1-.5.48L137 80.62Z",
    style: {
      fill: "#fff",
      transformOrigin: "135.791px 71.2208px"
    },
    id: "el24f19xtbqglh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.11 81.26-12.11-7 .63-.45a1.67 1.67 0 0 0 .38-.36l7.53-11.33a1.88 1.88 0 0 1 2.47-.58l9.21 5.3a1.89 1.89 0 0 1 .78 2.46l-2.07 4.14Zm-10.35-7.11L136.9 80l6.19-7.15 2-4a.86.86 0 0 0-.34-1.12l-9.21-5.29a.87.87 0 0 0-1.14.27L126.84 74Z",
    style: {
      fill: "#fff",
      transformOrigin: "135.592px 71.2804px"
    },
    id: "el7obqxr2a1mi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.08 120.51a3.1 3.1 0 0 1-.72.76l-9.31 6.56a2.34 2.34 0 0 0-.61.7l8.33 4.79 12.36-7Z",
    style: {
      fill: "#fff",
      transformOrigin: "81.785px 126.915px"
    },
    id: "elom75arominm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.77 133.89-9-5.18.27-.44a2.79 2.79 0 0 1 .76-.85l9.31-6.56a2.68 2.68 0 0 0 .59-.64l.27-.37 11.2 6.44Zm-7.59-5.51 7.59 4.36 11.35-6.46-8.91-5.12a3 3 0 0 1-.56.52l-9.31 6.56a.67.67 0 0 0-.16.14Z",
    style: {
      fill: "#fff",
      transformOrigin: "81.97px 126.87px"
    },
    id: "elx2tl5bf2u2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74 89.19a1.62 1.62 0 0 0-1.31.76l-7.49 13a1.53 1.53 0 0 0-.17.94l9.11 5.24 10.25-13.9Z",
    style: {
      fill: "#fff",
      transformOrigin: "88.4427px 99.16px"
    },
    id: "eltch6lkaepv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 109.76-9.71-5.58v-.25a2 2 0 0 1 .24-1.25L86 89.7a2.1 2.1 0 0 1 1.72-1h.15l11 6.39Zm-8.76-6.18 8.48 4.87 9.68-13.06-9.77-5.69a1.13 1.13 0 0 0-.77.5l-7.49 13a1 1 0 0 0-.11.38Z",
    style: {
      fill: "#fff",
      transformOrigin: "88.571px 99.23px"
    },
    id: "elutvkppuc9ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75 70.86 115.39 77l9.08-5.24v-3.68l-7.69-4.4a.82.82 0 0 0-.82.07l-10.19 5.88a2.77 2.77 0 0 0-1.02 1.23Z",
    style: {
      fill: "#fff",
      transformOrigin: "114.61px 70.3009px"
    },
    id: "elk52eydfhnnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.39 77.56-11.28-6.49.18-.41a3.21 3.21 0 0 1 1.23-1.46l10.19-5.88a1.34 1.34 0 0 1 1.31-.09l8 4.56V72Zm-10-6.89 10 5.73 8.58-5v-3.03l-7.44-4.26a.39.39 0 0 0-.32.07L106 70.07a2 2 0 0 0-.58.6Z",
    style: {
      fill: "#fff",
      transformOrigin: "114.565px 70.3302px"
    },
    id: "el23cm7nz4dv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 87.45a.85.85 0 0 0-.81 0l-9.07 4.09a1.08 1.08 0 0 1-1.51-.7c-.35-1.14-2.54-4.29-2.32-5.42l5.24-2.37a.87.87 0 0 1 .79 0Z",
    style: {
      fill: "#fff",
      transformOrigin: "151.137px 87.3003px"
    },
    id: "elc3yu8gmij2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.66 92.16A1.51 1.51 0 0 1 147 92a1.61 1.61 0 0 1-.88-1 15.24 15.24 0 0 0-.87-1.75c-1-1.77-1.63-3.08-1.48-3.91l.05-.26 5.49-2.47a1.81 1.81 0 0 1 .49-.14v-.28l.75.42 7.93 4.55v1.24l-.78-.52h-.32L148.35 92a1.73 1.73 0 0 1-.69.16Zm-2.86-6.4a13.37 13.37 0 0 0 1.37 3 13 13 0 0 1 .94 1.93.62.62 0 0 0 .34.41.6.6 0 0 0 .49 0l8.63-3.89-5.73-3.29-.75-.43a.42.42 0 0 0-.34 0Z",
    style: {
      fill: "#fff",
      transformOrigin: "151.114px 87.175px"
    },
    id: "el5wnmc2l7o6h",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.38 100V88.21a.76.76 0 0 0-1.16-.75l-9.07 4.09a1.08 1.08 0 0 1-1.51-.7 20.16 20.16 0 0 0-2-4.5 2.48 2.48 0 0 1-.13-2.19l6-12.19a1.38 1.38 0 0 0-.54-1.78l-6.56-3.79a1.37 1.37 0 0 0-1.8.43l-7.54 11.33a2.55 2.55 0 0 1-2 1 20.7 20.7 0 0 0-4.91.49 1.07 1.07 0 0 1-1.36-.95l-1-9.9a.76.76 0 0 0-1.23-.63L113.43 74a2.72 2.72 0 0 0-1.21 1.9l-1 11.34a3.77 3.77 0 0 1-1.06 2.12 63.32 63.32 0 0 0-5.66 6 2 2 0 0 1-2 .57l-6.54-2.29a1.61 1.61 0 0 0-1.84.69l-7.49 13a1.6 1.6 0 0 0 .33 1.93l5.25 4.53a2 2 0 0 1 .51 2 60.11 60.11 0 0 0-2.36 7.89 3.76 3.76 0 0 1-1.3 2l-9.31 6.55a2.74 2.74 0 0 0-1 2V146a.76.76 0 0 0 1.16.75l9.07-4.09a1.08 1.08 0 0 1 1.51.7 19.7 19.7 0 0 0 2 4.5 2.51 2.51 0 0 1 .14 2.2l-6 12.19a1.37 1.37 0 0 0 .54 1.77l6.56 3.79a1.37 1.37 0 0 0 1.8-.42l7.47-11.34a2.49 2.49 0 0 1 2-1 20.22 20.22 0 0 0 4.91-.5 1.08 1.08 0 0 1 1.36 1l1 9.9a.76.76 0 0 0 1.23.63l10.19-5.89a2.76 2.76 0 0 0 1.22-1.9l1-11.34a3.71 3.71 0 0 1 1.06-2.11 63.32 63.32 0 0 0 5.66-6 1.94 1.94 0 0 1 2-.57l6.54 2.28a1.6 1.6 0 0 0 1.84-.68l7.49-13a1.6 1.6 0 0 0-.33-1.93l-5.25-4.52a2 2 0 0 1-.51-2 60.24 60.24 0 0 0 2.36-7.9 3.79 3.79 0 0 1 1.31-2l9.31-6.56a2.75 2.75 0 0 0 .99-1.96Zm-39.85 37c-9.51 5.49-17.22 1-17.22-9.94s7.71-24.33 17.22-29.82 17.21-1 17.21 9.94S128 131.49 118.53 137Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "118.565px 117.106px"
    },
    id: "elloeoiv9pzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "118.507px 117.091px"
    },
    className: "animable",
    id: "elfb9nz6kdo5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.38 100V88.21a.76.76 0 0 0-1.16-.75l-9.07 4.09a1.08 1.08 0 0 1-1.51-.7 20.16 20.16 0 0 0-2-4.5 2.48 2.48 0 0 1-.13-2.19l6-12.19a1.38 1.38 0 0 0-.54-1.78l-6.56-3.79a1.37 1.37 0 0 0-1.8.43l-7.54 11.33a2.55 2.55 0 0 1-2 1 20.7 20.7 0 0 0-4.91.49 1.07 1.07 0 0 1-1.36-.95l-1-9.9a.76.76 0 0 0-1.23-.63L113.43 74a2.72 2.72 0 0 0-1.21 1.9l-1 11.34a3.77 3.77 0 0 1-1.06 2.12 63.32 63.32 0 0 0-5.66 6 2 2 0 0 1-2 .57l-6.54-2.29a1.61 1.61 0 0 0-1.84.69l-7.49 13a1.6 1.6 0 0 0 .33 1.93l5.25 4.53a2 2 0 0 1 .51 2 60.11 60.11 0 0 0-2.36 7.89 3.76 3.76 0 0 1-1.3 2l-9.31 6.55a2.74 2.74 0 0 0-1 2V146a.76.76 0 0 0 1.16.75l9.07-4.09a1.08 1.08 0 0 1 1.51.7 19.7 19.7 0 0 0 2 4.5 2.51 2.51 0 0 1 .14 2.2l-6 12.19a1.37 1.37 0 0 0 .54 1.77l6.56 3.79a1.37 1.37 0 0 0 1.8-.42l7.47-11.34a2.49 2.49 0 0 1 2-1 20.22 20.22 0 0 0 4.91-.5 1.08 1.08 0 0 1 1.36 1l1 9.9a.76.76 0 0 0 1.23.63l10.19-5.89a2.76 2.76 0 0 0 1.22-1.9l1-11.34a3.71 3.71 0 0 1 1.06-2.11 63.32 63.32 0 0 0 5.66-6 1.94 1.94 0 0 1 2-.57l6.54 2.28a1.6 1.6 0 0 0 1.84-.68l7.49-13a1.6 1.6 0 0 0-.33-1.93l-5.25-4.52a2 2 0 0 1-.51-2 60.24 60.24 0 0 0 2.36-7.9 3.79 3.79 0 0 1 1.31-2l9.31-6.56a2.75 2.75 0 0 0 .99-1.96Zm-39.85 37c-9.51 5.49-17.22 1-17.22-9.94s7.71-24.33 17.22-29.82 17.21-1 17.21 9.94S128 131.49 118.53 137Z",
    style: {
      fill: "#fff",
      transformOrigin: "118.565px 117.106px"
    },
    id: "elcjkwmj2p4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.29 168.48a1.76 1.76 0 0 1-.91-.25l-6.56-3.78a1.89 1.89 0 0 1-.74-2.43l6-12.19a2 2 0 0 0-.12-1.72 21 21 0 0 1-2.07-4.61.64.64 0 0 0-.34-.41.6.6 0 0 0-.49 0L80 147.2a1.35 1.35 0 0 1-1.3 0 1.34 1.34 0 0 1-.56-1.17v-11.8a3.29 3.29 0 0 1 1.25-2.42l9.31-6.55a3.27 3.27 0 0 0 1.1-1.68 62.91 62.91 0 0 1 2.38-8 1.45 1.45 0 0 0-.37-1.46l-5.25-4.53a2.1 2.1 0 0 1-.43-2.56l7.49-13a2.09 2.09 0 0 1 2.43-.91l6.55 2.29a1.47 1.47 0 0 0 1.45-.42 62.28 62.28 0 0 1 5.71-6 3.3 3.3 0 0 0 .9-1.79l1-11.34a3.24 3.24 0 0 1 1.46-2.29l10.19-5.89a1.38 1.38 0 0 1 1.3-.09 1.35 1.35 0 0 1 .68 1.11l1 9.9a.61.61 0 0 0 .23.43.68.68 0 0 0 .53.09 20.93 20.93 0 0 1 5-.51 2.08 2.08 0 0 0 1.55-.76l7.53-11.33a1.88 1.88 0 0 1 2.47-.58l6.56 3.79a1.87 1.87 0 0 1 .74 2.43l-6.05 12.19a2 2 0 0 0 .12 1.71 21 21 0 0 1 2.07 4.61.62.62 0 0 0 .34.41.56.56 0 0 0 .49 0L157 87a1.25 1.25 0 0 1 1.87 1.2V100a3.23 3.23 0 0 1-1.26 2.41l-9.31 6.55a3.33 3.33 0 0 0-1.1 1.68 59.79 59.79 0 0 1-2.38 8 1.47 1.47 0 0 0 .37 1.47l5.25 4.52a2.07 2.07 0 0 1 .43 2.56l-7.49 13a2.08 2.08 0 0 1-2.43.9l-6.54-2.28a1.48 1.48 0 0 0-1.46.41 62.27 62.27 0 0 1-5.7 6 3.36 3.36 0 0 0-.9 1.8l-1 11.34a3.23 3.23 0 0 1-1.46 2.29l-10.19 5.88a1.25 1.25 0 0 1-2-1l-1-9.9a.58.58 0 0 0-.23-.43.68.68 0 0 0-.53-.09 20.88 20.88 0 0 1-5 .51 2 2 0 0 0-1.55.76l-7.53 11.33a1.89 1.89 0 0 1-1.57.77Zm-4.91-26.43a1.51 1.51 0 0 1 .63.13 1.63 1.63 0 0 1 .88 1 19.55 19.55 0 0 0 2 4.39 3 3 0 0 1 .15 2.68l-6 12.19a.86.86 0 0 0 .34 1.12l6.56 3.79a.88.88 0 0 0 1.06-.25l7.53-11.33a2.94 2.94 0 0 1 2.4-1.2 20 20 0 0 0 4.79-.49 1.67 1.67 0 0 1 1.33.26 1.6 1.6 0 0 1 .64 1.14l1 9.9c0 .16.07.28.14.31a.38.38 0 0 0 .34-.06l10.19-5.89a2.27 2.27 0 0 0 1-1.51l1-11.34a4.28 4.28 0 0 1 1.22-2.44 61.4 61.4 0 0 0 5.61-5.94 2.44 2.44 0 0 1 2.55-.72l6.55 2.28a1.09 1.09 0 0 0 1.23-.46l7.5-13a1.09 1.09 0 0 0-.22-1.3l-5.25-4.52a2.44 2.44 0 0 1-.65-2.57 63.14 63.14 0 0 0 2.34-7.84 4.21 4.21 0 0 1 1.5-2.27l9.31-6.56a2.25 2.25 0 0 0 .83-1.59V88.21a.44.44 0 0 0-.11-.33.42.42 0 0 0-.35 0L148.35 92a1.58 1.58 0 0 1-1.35 0 1.61 1.61 0 0 1-.88-1 19.9 19.9 0 0 0-2-4.38 3 3 0 0 1-.16-2.69l6-12.19a.87.87 0 0 0-.34-1.12l-6.56-3.78a.88.88 0 0 0-1.14.26l-7.42 11.33a3.06 3.06 0 0 1-2.4 1.21 20 20 0 0 0-4.79.48 1.6 1.6 0 0 1-1.32-.25 1.55 1.55 0 0 1-.64-1.14l-1-9.9a.4.4 0 0 0-.14-.32.39.39 0 0 0-.34.07l-10.19 5.88a2.26 2.26 0 0 0-1 1.52l-1 11.34a4.28 4.28 0 0 1-1.22 2.44 61.4 61.4 0 0 0-5.61 5.94 2.45 2.45 0 0 1-2.55.72l-6.55-2.28a1.07 1.07 0 0 0-1.23.46l-7.5 13a1.1 1.1 0 0 0 .23 1.31l5.24 4.52a2.47 2.47 0 0 1 .66 2.57 59.77 59.77 0 0 0-2.34 7.83 4.26 4.26 0 0 1-1.51 2.28l-9.3 6.52a2.26 2.26 0 0 0-.82 1.6V146a.41.41 0 0 0 .11.33.42.42 0 0 0 .34 0l9.07-4.09a1.67 1.67 0 0 1 .68-.19Zm21.46-2.21a9.3 9.3 0 0 1-4.74-1.22c-3.41-2-5.29-6.08-5.29-11.58 0-11.12 7.84-24.69 17.47-30.25C123 94 127.54 93.61 131 95.58s5.29 6.09 5.29 11.58c0 11.12-7.83 24.69-17.46 30.26a16.19 16.19 0 0 1-7.99 2.42Zm15.37-44.47a15 15 0 0 0-7.43 2.29c-9.36 5.4-17 18.58-17 29.38 0 5.13 1.7 8.93 4.79 10.71s7.24 1.36 11.68-1.2c9.35-5.4 17-18.59 17-29.39 0-5.12-1.7-8.93-4.79-10.71a8.41 8.41 0 0 0-4.25-1.08Z",
    style: {
      fill: "#fff",
      transformOrigin: "118.507px 117.091px"
    },
    id: "elw1git6xhz2f",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.84 179.69a.82.82 0 0 0-.89.09l-4.29 2.82a1.25 1.25 0 0 1-1.72-.39 9.44 9.44 0 0 0-.83-1 2.14 2.14 0 0 1-.51-2.05l6.82-4.32-5.09-2.93a1.51 1.51 0 0 0-.34-.13l-3.23-.78a1.73 1.73 0 0 0-1.83.84l-3 5.8a3.24 3.24 0 0 1-1.84 1.38l-.19.05a7.28 7.28 0 0 0 .27-1.35l-5.17-2.9a.86.86 0 0 0-1 .14l-4.84 3.8a2.75 2.75 0 0 0-.92 2.06l.29 4.61a3.69 3.69 0 0 1-.76 2.23c-.79 1-1.54 1.94-2.24 3a2.5 2.5 0 0 1-2 1l-3.11-.15a2 2 0 0 0-1.79 1.1l-2.93 6.56a1.25 1.25 0 0 0 .5 1.58l3.45 2a1.51 1.51 0 0 1 .09.89 27 27 0 0 0-.54 3.13 4 4 0 0 1-1.05 2.13L65 212.81a2.6 2.6 0 0 0-.72 2.12l.8 4.68a.87.87 0 0 0 .39.63l5.12 2.95.07-5.86a1.24 1.24 0 0 1 1.72.39 9.44 9.44 0 0 0 .83 1 2.12 2.12 0 0 1 .51 2l-2.19 5.92a1.07 1.07 0 0 0 .37 1.36l5.1 3 1.39-3.81 2-4.91a3.2 3.2 0 0 1 1.84-1.38 14 14 0 0 0 2-.66 1.11 1.11 0 0 1 1.53.7l1.09 3.63a.94.94 0 0 0 .42.57l5.13 2.95-.9-5.66 1.5-1.26a2.68 2.68 0 0 0 .92-2l-.29-4.61a3.69 3.69 0 0 1 .76-2.23c.79-.95 2-1.46 2.69-2.49.4-.58.83-1.52 1.53-1.49l3.11.16a2 2 0 0 0 1.79-1.1l2.93-6.56a1.25 1.25 0 0 0-.66-1.66l-2.51-1.08a1.54 1.54 0 0 1-.86-1.73 27.29 27.29 0 0 0 .53-3.13 4 4 0 0 1 1-2.13l4.3-3.95a2.65 2.65 0 0 0 .71-1.46l3.89-3ZM88.35 210c-5.25 4.13-10.28 3-11.23-2.51s3.35-12.52 8.6-16.64 9.47-3.82 10.42 1.7-2.54 13.27-7.79 17.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "88.551px 200.984px"
    },
    id: "el92gtsw1mpif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.84 179.69a.82.82 0 0 0-.89.09l-4.29 2.82a1.25 1.25 0 0 1-1.72-.39 9.44 9.44 0 0 0-.83-1 2.14 2.14 0 0 1-.51-2.05l6.82-4.32-5.09-2.93a1.51 1.51 0 0 0-.34-.13l-3.23-.78a1.73 1.73 0 0 0-1.83.84l-3 5.8a3.24 3.24 0 0 1-1.84 1.38l-.19.05a7.28 7.28 0 0 0 .27-1.35l-5.17-2.9a.86.86 0 0 0-1 .14l-4.84 3.8a2.75 2.75 0 0 0-.92 2.06l.29 4.61a3.69 3.69 0 0 1-.76 2.23c-.79 1-1.54 1.94-2.24 3a2.5 2.5 0 0 1-2 1l-3.11-.15a2 2 0 0 0-1.79 1.1l-2.93 6.56a1.25 1.25 0 0 0 .5 1.58l3.45 2a1.51 1.51 0 0 1 .09.89 27 27 0 0 0-.54 3.13 4 4 0 0 1-1.05 2.13L65 212.81a2.6 2.6 0 0 0-.72 2.12l.8 4.68a.87.87 0 0 0 .39.63l5.12 2.95.07-5.86a1.24 1.24 0 0 1 1.72.39 9.44 9.44 0 0 0 .83 1 2.12 2.12 0 0 1 .51 2l-2.19 5.92a1.07 1.07 0 0 0 .37 1.36l5.1 3 1.39-3.81 2-4.91a3.2 3.2 0 0 1 1.84-1.38 14 14 0 0 0 2-.66 1.11 1.11 0 0 1 1.53.7l1.09 3.63a.94.94 0 0 0 .42.57l5.13 2.95-.9-5.66 1.5-1.26a2.68 2.68 0 0 0 .92-2l-.29-4.61a3.69 3.69 0 0 1 .76-2.23c.79-.95 2-1.46 2.69-2.49.4-.58.83-1.52 1.53-1.49l3.11.16a2 2 0 0 0 1.79-1.1l2.93-6.56a1.25 1.25 0 0 0-.66-1.66l-2.51-1.08a1.54 1.54 0 0 1-.86-1.73 27.29 27.29 0 0 0 .53-3.13 4 4 0 0 1 1-2.13l4.3-3.95a2.65 2.65 0 0 0 .71-1.46l3.89-3ZM88.35 210c-5.25 4.13-10.28 3-11.23-2.51s3.35-12.52 8.6-16.64 9.47-3.82 10.42 1.7-2.54 13.27-7.79 17.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "88.551px 200.984px"
    },
    className: "animable",
    id: "elcyfbschrt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.19 220.74-8.74-.89-8.13-4.69-1.87 4a2 2 0 0 1 .21 1.63l-2.19 5.92a1.07 1.07 0 0 0 .43 1.29l5.1 3 1.39-3.81 2-4.91a3.2 3.2 0 0 1 1.84-1.38 13.63 13.63 0 0 0 2-.66 1.11 1.11 0 0 1 1.53.7l1.09 3.63a.94.94 0 0 0 .42.57l5.13 2.95-.9-5.66 1-.77Z",
    style: {
      opacity: 0.1,
      transformOrigin: "81.9494px 223.08px"
    },
    className: "animable",
    id: "elwd5xy7xw6fs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102 189.36-6.33-3.08-1.47 2.41a5.7 5.7 0 0 1 2 3.81c1 5.51-2.54 13.32-7.79 17.45-3.14 2.47-6.2 3.05-8.36 1.94l-.56.92s3.61 5.48 8.08 4.46a17.37 17.37 0 0 0 6.18-3.16 3.69 3.69 0 0 1 .73-1.83c.79-.95 2-1.46 2.69-2.49.4-.58.83-1.52 1.53-1.49h.47a14.41 14.41 0 0 0 1.31-2.56c2.02-5.38 1.52-16.38 1.52-16.38Z",
    style: {
      opacity: 0.1,
      transformOrigin: "90.7724px 201.838px"
    },
    className: "animable",
    id: "elusiz8ove4tr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.19 208.91-4.19 3.9a2.49 2.49 0 0 0-.66 1.23l6.3 3.63v-.33a1.24 1.24 0 0 1 1.72.39l6.08-3.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "71.39px 213.32px"
    },
    id: "elo2awf1pqokf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 197.1q.72-1.11 1.56-2.16l-6-3.5a1.91 1.91 0 0 1-.89.19l-3.11-.15a2 2 0 0 0-1.29.47l9.31 5.37Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "75.915px 194.38px"
    },
    id: "elz7ykx8azii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92 182.62a.81.81 0 0 0-.87.1l-4.29 2.82a1.25 1.25 0 0 1-1.72-.39 7.6 7.6 0 0 0-.84-1 2.16 2.16 0 0 1-.5-2l.41-1.09 1.84-1.21a.82.82 0 0 1 .89-.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "108.776px 182.7px"
    },
    id: "elv5mx1dg5nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.25 181.36c0-.05-.09-.12-.14-.17a2.14 2.14 0 0 1-.51-2.05l6.82-4.32-5.09-2.93a1.51 1.51 0 0 0-.34-.13l-3.23-.76a1.73 1.73 0 0 0-1.83.84l-3 5.8a2.78 2.78 0 0 1-.7.77l6.87 4Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "99.325px 176.689px"
    },
    id: "elart1r2xk2q4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.43 180 6.31 3.64 5.18-4.75a7.45 7.45 0 0 0 .21-1.16L86 174.82a.86.86 0 0 0-1 .14l-4.84 3.8a2.77 2.77 0 0 0-.73 1.24Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "85.28px 179.18px"
    },
    id: "elxq1834vvff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "88.46px 194.509px"
    },
    className: "animable",
    id: "el0k8opnrwo8cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.19 208.91-4.19 3.9a2.49 2.49 0 0 0-.66 1.23l6.3 3.63v-.33a1.24 1.24 0 0 1 1.72.39l6.08-3.5Z",
    style: {
      fill: "#fff",
      transformOrigin: "71.39px 213.32px"
    },
    id: "elx77ta6iikae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.08 218.54-7.36-4.26.08-.36a3 3 0 0 1 .81-1.48l4.51-4.15 10.28 5.94-7.25 4.18-.25-.41a.79.79 0 0 0-.81-.33Zm.17-1.9a1.79 1.79 0 0 1 1.18.46l5-2.87-8.14-4.7-4 3.65a1.69 1.69 0 0 0-.39.62l5.42 3.13a1.68 1.68 0 0 1 .93-.29Z",
    style: {
      fill: "#fff",
      transformOrigin: "71.56px 213.415px"
    },
    id: "el4wqt42ax1qq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 197.1q.72-1.11 1.56-2.16l-6-3.5a1.91 1.91 0 0 1-.89.19l-3.11-.15a2 2 0 0 0-1.29.47l9.31 5.37Z",
    style: {
      fill: "#fff",
      transformOrigin: "75.915px 194.38px"
    },
    id: "elvpgzk4ggrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.51 197.89 69.35 192l.55-.46a2.52 2.52 0 0 1 1.64-.58l3.11.15a1.44 1.44 0 0 0 .67-.15l.23-.09 6.77 3.91-.37.45a25.18 25.18 0 0 0-1.53 2.12l-.08.12ZM71.29 192l8.26 4.77h.11c.36-.55.74-1.09 1.15-1.63L75.47 192a2.55 2.55 0 0 1-.87.13l-3.11-.13Z",
    style: {
      fill: "#fff",
      transformOrigin: "75.835px 194.38px"
    },
    id: "els0cjqh47jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92 182.62a.81.81 0 0 0-.87.1l-4.29 2.82a1.25 1.25 0 0 1-1.72-.39 7.6 7.6 0 0 0-.84-1 2.16 2.16 0 0 1-.5-2l.41-1.09 1.84-1.21a.82.82 0 0 1 .89-.09Z",
    style: {
      fill: "#fff",
      transformOrigin: "108.776px 182.7px"
    },
    id: "elfgphexkzkbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.11 186.24a1.82 1.82 0 0 1-1.48-.8 7.36 7.36 0 0 0-.79-1 2.63 2.63 0 0 1-.61-2.56l.47-1.25 2-1.3a1.67 1.67 0 0 1 .67-.25v-.28l.75.42 5.08 2.93-.49.87a.37.37 0 0 0-.35.09L108 186a1.68 1.68 0 0 1-.89.24Zm-1.59-4.92-.35.94a1.64 1.64 0 0 0 .39 1.52 9.33 9.33 0 0 1 .89 1.08.76.76 0 0 0 1 .26l4.1-2.7-3.25-1.87-.76-.45c-.08-.05-.21 0-.36.08Z",
    style: {
      fill: "#fff",
      transformOrigin: "108.66px 182.52px"
    },
    id: "elbb8woijfda5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.25 181.36c0-.05-.09-.12-.14-.17a2.14 2.14 0 0 1-.51-2.05l6.82-4.32-5.09-2.93a1.51 1.51 0 0 0-.34-.13l-3.23-.76a1.73 1.73 0 0 0-1.83.84l-3 5.8a2.78 2.78 0 0 1-.7.77l6.87 4Z",
    style: {
      fill: "#fff",
      transformOrigin: "99.325px 176.689px"
    },
    id: "elz25a2hxd91q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.12 183-7.81-4.51.57-.46a2 2 0 0 0 .56-.62l3-5.79a2.25 2.25 0 0 1 2.39-1.1l3.23.72h.05l.39.22 5.8 3.34-7.3 4.66a1.73 1.73 0 0 0 .44 1.38l.11.13.34.38-.34.38ZM93 178.35l6 3.45.56-.49a2.6 2.6 0 0 1-.43-2.34l.06-.16 6.26-4-4.37-2.51a.75.75 0 0 0-.2-.08l-3.23-.73a1.27 1.27 0 0 0-1.28.6l-3 5.79a2.08 2.08 0 0 1-.37.47Z",
    style: {
      fill: "#fff",
      transformOrigin: "99.305px 176.739px"
    },
    id: "el4xhoya5smsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.43 180 6.31 3.64 5.18-4.75a7.45 7.45 0 0 0 .21-1.16L86 174.82a.86.86 0 0 0-1 .14l-4.84 3.8a2.77 2.77 0 0 0-.73 1.24Z",
    style: {
      fill: "#fff",
      transformOrigin: "85.28px 179.18px"
    },
    id: "elp2wzu3e5pi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.81 184.29-7-4 .12-.38a3.05 3.05 0 0 1 1-1.52l4.84-3.81a1.69 1.69 0 0 1 .6-.3l-.13-.48 6.43 3.71v.32a9.35 9.35 0 0 1-.23 1.25v.14Zm-5.76-4.48 5.62 3.25 4.8-4.4a4.3 4.3 0 0 0 .12-.63l-3.76-2.17-1-.61c-.14-.08-.31 0-.4.09l-4.84 3.81a2 2 0 0 0-.54.66Z",
    style: {
      fill: "#fff",
      transformOrigin: "85.24px 179.045px"
    },
    id: "elhjsigp4repd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m114.13 188-.8-4.68a.77.77 0 0 0-1.28-.55l-4.29 2.82a1.24 1.24 0 0 1-1.72-.39 9.44 9.44 0 0 0-.83-1 2.12 2.12 0 0 1-.51-2l2.19-5.92a1.08 1.08 0 0 0-.8-1.47l-3.23-.72a1.72 1.72 0 0 0-1.83.85l-3 5.79a3.2 3.2 0 0 1-1.88 1.27 13.63 13.63 0 0 0-2 .66 1.11 1.11 0 0 1-1.53-.7l-1.09-3.63a.81.81 0 0 0-1.37-.43l-4.84 3.81a2.68 2.68 0 0 0-.92 2l.29 4.61a3.69 3.69 0 0 1-.76 2.23c-.79 1-1.54 2-2.25 3a2.51 2.51 0 0 1-2 1l-3.11-.16a2 2 0 0 0-1.79 1.1l-2.93 6.56a1.25 1.25 0 0 0 .66 1.66l2.51 1.08a1.54 1.54 0 0 1 .86 1.73 27.29 27.29 0 0 0-.53 3.13 4 4 0 0 1-1 2.13L70 215.76a2.61 2.61 0 0 0-.72 2.11l.81 4.68a.77.77 0 0 0 1.28.55l4.29-2.82a1.25 1.25 0 0 1 1.72.39 9.44 9.44 0 0 0 .83 1 2.14 2.14 0 0 1 .51 2.05l-2.19 5.91a1.08 1.08 0 0 0 .8 1.47l3.23.72a1.73 1.73 0 0 0 1.83-.84l3-5.8a3.24 3.24 0 0 1 1.84-1.38 15.35 15.35 0 0 0 2-.65 1.1 1.1 0 0 1 1.53.69l1.09 3.63a.81.81 0 0 0 1.37.43l4.84-3.8a2.75 2.75 0 0 0 .92-2.06l-.29-4.61a3.69 3.69 0 0 1 .76-2.23c.79-.95 1.54-1.94 2.25-3a2.45 2.45 0 0 1 2-1l3.11.15a2 2 0 0 0 1.79-1.1l2.93-6.56a1.25 1.25 0 0 0-.66-1.66L108.4 201a1.55 1.55 0 0 1-.87-1.73 27 27 0 0 0 .54-3.13 4 4 0 0 1 1.05-2.13l4.29-3.94a2.6 2.6 0 0 0 .72-2.07Zm-20.68 24.89c-5.25 4.13-10.28 3-11.23-2.51s2.54-13.33 7.79-17.45 10.28-3 11.22 2.51-2.53 13.33-7.78 17.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "91.7033px 202.955px"
    },
    id: "elpmmlq4f0qhs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "91.6588px 202.94px"
    },
    className: "animable",
    id: "elok4gfdp19u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.13 188-.8-4.68a.77.77 0 0 0-1.28-.55l-4.29 2.82a1.24 1.24 0 0 1-1.72-.39 9.44 9.44 0 0 0-.83-1 2.12 2.12 0 0 1-.51-2l2.19-5.92a1.08 1.08 0 0 0-.8-1.47l-3.23-.72a1.72 1.72 0 0 0-1.83.85l-3 5.79a3.2 3.2 0 0 1-1.88 1.27 13.63 13.63 0 0 0-2 .66 1.11 1.11 0 0 1-1.53-.7l-1.09-3.63a.81.81 0 0 0-1.37-.43l-4.84 3.81a2.68 2.68 0 0 0-.92 2l.29 4.61a3.69 3.69 0 0 1-.76 2.23c-.79 1-1.54 2-2.25 3a2.51 2.51 0 0 1-2 1l-3.11-.16a2 2 0 0 0-1.79 1.1l-2.93 6.56a1.25 1.25 0 0 0 .66 1.66l2.51 1.08a1.54 1.54 0 0 1 .86 1.73 27.29 27.29 0 0 0-.53 3.13 4 4 0 0 1-1 2.13L70 215.76a2.61 2.61 0 0 0-.72 2.11l.81 4.68a.77.77 0 0 0 1.28.55l4.29-2.82a1.25 1.25 0 0 1 1.72.39 9.44 9.44 0 0 0 .83 1 2.14 2.14 0 0 1 .51 2.05l-2.19 5.91a1.08 1.08 0 0 0 .8 1.47l3.23.72a1.73 1.73 0 0 0 1.83-.84l3-5.8a3.24 3.24 0 0 1 1.84-1.38 15.35 15.35 0 0 0 2-.65 1.1 1.1 0 0 1 1.53.69l1.09 3.63a.81.81 0 0 0 1.37.43l4.84-3.8a2.75 2.75 0 0 0 .92-2.06l-.29-4.61a3.69 3.69 0 0 1 .76-2.23c.79-.95 1.54-1.94 2.25-3a2.45 2.45 0 0 1 2-1l3.11.15a2 2 0 0 0 1.79-1.1l2.93-6.56a1.25 1.25 0 0 0-.66-1.66L108.4 201a1.55 1.55 0 0 1-.87-1.73 27 27 0 0 0 .54-3.13 4 4 0 0 1 1.05-2.13l4.29-3.94a2.6 2.6 0 0 0 .72-2.07Zm-20.68 24.89c-5.25 4.13-10.28 3-11.23-2.51s2.54-13.33 7.79-17.45 10.28-3 11.22 2.51-2.53 13.33-7.78 17.45Z",
    style: {
      fill: "#fff",
      transformOrigin: "91.7033px 202.955px"
    },
    id: "el75vertfiipc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92 232.38a2 2 0 0 1-.43 0l-3.23-.72a1.63 1.63 0 0 1-1.08-.79 1.61 1.61 0 0 1-.08-1.34l2.19-5.92a1.64 1.64 0 0 0-.4-1.52A9.21 9.21 0 0 1 77 221a.75.75 0 0 0-1-.26l-4.29 2.82a1.26 1.26 0 0 1-2-.89l-.88-4.67a3.08 3.08 0 0 1 .88-2.56l4.29-4a3.45 3.45 0 0 0 .89-1.81 28.81 28.81 0 0 1 .55-3.19 1.06 1.06 0 0 0-.58-1.16l-2.51-1.08a1.74 1.74 0 0 1-.95-1 1.71 1.71 0 0 1 0-1.35l2.92-6.56a2.51 2.51 0 0 1 2.27-1.4l3.12.16a2.05 2.05 0 0 0 1.53-.79c.72-1 1.49-2.06 2.28-3a3.21 3.21 0 0 0 .64-1.88l-.29-4.61a3.2 3.2 0 0 1 1.13-2.46l4.84-3.8a1.38 1.38 0 0 1 1.28-.29 1.41 1.41 0 0 1 .88 1l1.09 3.62a.61.61 0 0 0 .31.39.7.7 0 0 0 .55 0 16.51 16.51 0 0 1 2.06-.68 2.62 2.62 0 0 0 1.51-1.13l3-5.79a2.26 2.26 0 0 1 2.39-1.1l3.23.72a1.62 1.62 0 0 1 1.08.8 1.58 1.58 0 0 1 .08 1.33l-2.19 5.92a1.64 1.64 0 0 0 .4 1.52 9.52 9.52 0 0 1 .88 1.09.75.75 0 0 0 1 .25l4.29-2.82a1.26 1.26 0 0 1 2 .89l.81 4.68a3.15 3.15 0 0 1-.88 2.57l-4.29 3.94a3.44 3.44 0 0 0-.89 1.82 29 29 0 0 1-.55 3.18 1.06 1.06 0 0 0 .57 1.16l2.52 1.08a1.69 1.69 0 0 1 .94 1 1.67 1.67 0 0 1 0 1.35l-2.93 6.56a2.5 2.5 0 0 1-2.27 1.4l-3.11-.15a2 2 0 0 0-1.53.78c-.72 1.05-1.49 2.06-2.28 3a3.21 3.21 0 0 0-.64 1.88l.29 4.61a3.22 3.22 0 0 1-1.11 2.48l-4.84 3.81a1.31 1.31 0 0 1-2.16-.68l-.98-3.7a.6.6 0 0 0-.31-.38.66.66 0 0 0-.55 0 15.5 15.5 0 0 1-2.06.68 2.66 2.66 0 0 0-1.51 1.13l-3 5.79a2.3 2.3 0 0 1-2 1.16Zm-4.57-12.8a1.82 1.82 0 0 1 1.48.8 7.43 7.43 0 0 0 .79 1 2.63 2.63 0 0 1 .61 2.56L77 229.82a.62.62 0 0 0 0 .52.6.6 0 0 0 .42.29l3.23.73a1.27 1.27 0 0 0 1.28-.6L85 225a3.68 3.68 0 0 1 2.16-1.63 14.9 14.9 0 0 0 1.92-.64 1.73 1.73 0 0 1 1.36 0 1.65 1.65 0 0 1 .84 1l1.09 3.63a.43.43 0 0 0 .22.3.47.47 0 0 0 .36-.12l4.84-3.81a2.2 2.2 0 0 0 .73-1.63l-.29-4.61a4.12 4.12 0 0 1 .87-2.58 34.79 34.79 0 0 0 2.22-2.94 3 3 0 0 1 2.41-1.21l3.11.15a1.48 1.48 0 0 0 1.31-.8l2.93-6.57a.75.75 0 0 0-.39-1l-2.52-1.08a2 2 0 0 1-1.15-2.3c.23-1 .41-2.08.53-3.08a4.32 4.32 0 0 1 1.2-2.43l4.3-4a2.12 2.12 0 0 0 .56-1.66l-.8-4.68c0-.16-.09-.28-.17-.31a.38.38 0 0 0-.34.09L108 186a1.75 1.75 0 0 1-2.41-.52 8.35 8.35 0 0 0-.79-1 2.63 2.63 0 0 1-.61-2.56l2.19-5.91a.58.58 0 0 0-.44-.81l-3.23-.72a1.24 1.24 0 0 0-1.28.59l-3 5.79a3.64 3.64 0 0 1-2.16 1.63 16 16 0 0 0-1.92.64 1.65 1.65 0 0 1-1.36 0 1.62 1.62 0 0 1-.84-1l-1.09-3.63a.41.41 0 0 0-.22-.29.39.39 0 0 0-.36.11l-4.84 3.81a2.16 2.16 0 0 0-.73 1.63l.29 4.61a4.14 4.14 0 0 1-.87 2.58 36.48 36.48 0 0 0-2.22 2.94 3 3 0 0 1-2.41 1.22l-3.12-.16a1.47 1.47 0 0 0-1.3.8l-2.93 6.57a.73.73 0 0 0 0 .58.7.7 0 0 0 .4.41l2.52 1.08a2.05 2.05 0 0 1 1.15 2.3c-.23 1-.41 2.08-.53 3.08a4.39 4.39 0 0 1-1.21 2.44l-4.29 3.94a2.12 2.12 0 0 0-.56 1.66l.8 4.68c0 .16.09.28.17.31a.4.4 0 0 0 .34-.08l4.29-2.83a1.68 1.68 0 0 1 .92-.31Zm11.06-3.7a5.82 5.82 0 0 1-2-.36c-1.9-.74-3.19-2.53-3.63-5.05-1-5.67 2.6-13.71 8-17.94 3-2.32 6-3.14 8.4-2.22 1.9.73 3.19 2.52 3.63 5 1 5.67-2.6 13.72-8 17.94a10.68 10.68 0 0 1-6.4 2.63ZM96 190.94a9.7 9.7 0 0 0-5.72 2.38c-5.11 4-8.52 11.64-7.6 17 .37 2.19 1.41 3.67 3 4.28 2 .78 4.74 0 7.42-2.08 5.11-4 8.52-11.63 7.6-17-.38-2.19-1.41-3.67-3-4.28a4.79 4.79 0 0 0-1.7-.3Z",
    style: {
      fill: "#fff",
      transformOrigin: "91.6588px 202.94px"
    },
    id: "elsdr3sijjyd",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Controls--inject-127",
    className: "animable",
    style: {
      transformOrigin: "329.12px 85.03px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--controls--inject-127",
    className: "animable",
    style: {
      transformOrigin: "329.12px 85.03px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m291.62 83 75-43.52c1.41-.81 2.54-.24 2.54 1.28a5.43 5.43 0 0 1-2.5 4.24l-75 43.52c-1.41.81-2.54.24-2.54-1.28a5.46 5.46 0 0 1 2.5-4.24Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "329.14px 64px"
    },
    id: "elqzs2j5837xk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.62 83 75-43.52c1.41-.81 2.54-.24 2.54 1.28a5.43 5.43 0 0 1-2.5 4.24l-75 43.52c-1.41.81-2.54.24-2.54-1.28a5.46 5.46 0 0 1 2.5-4.24Z",
    style: {
      fill: "#fff",
      opacity: 0.9,
      transformOrigin: "329.14px 64px"
    },
    className: "animable",
    id: "el161oykaqmr6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36 71.09 291.62 83a5.46 5.46 0 0 0-2.54 4.23c0 1.52 1.13 2.09 2.54 1.28l20.74-12Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "300.72px 79.9841px"
    },
    className: "animable",
    id: "elkcph909jmvc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 78.85a5.88 5.88 0 0 0 .42 2.31l7.92-4.56v-5.51l-7.76 4.48a10.7 10.7 0 0 0-.58 3.28Z",
    style: {
      opacity: 0.05,
      transformOrigin: "308.169px 76.125px"
    },
    className: "animable",
    id: "eliw8cc6206vr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36 66.86c3.35-1.93 6.06-.37 6.06 3.49a13.38 13.38 0 0 1-6.06 10.49c-3.34 1.93-6.05.36-6.05-3.5a13.38 13.38 0 0 1 6.05-10.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "312.365px 73.849px"
    },
    id: "elfkzfi0hyboc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36 66.86c3.35-1.93 6.06-.37 6.06 3.49a13.38 13.38 0 0 1-6.06 10.49c-3.34 1.93-6.05.36-6.05-3.5a13.38 13.38 0 0 1 6.05-10.48Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "312.365px 73.849px"
    },
    className: "animable",
    id: "elhdptccxhgtt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.62 104 75-43.52c1.41-.81 2.54-.24 2.54 1.28a5.43 5.43 0 0 1-2.5 4.24l-75 43.52c-1.41.81-2.54.24-2.54-1.28a5.46 5.46 0 0 1 2.5-4.24Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "329.14px 85px"
    },
    id: "elul5v5surwig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.62 104 75-43.52c1.41-.81 2.54-.24 2.54 1.28a5.43 5.43 0 0 1-2.5 4.24l-75 43.52c-1.41.81-2.54.24-2.54-1.28a5.46 5.46 0 0 1 2.5-4.24Z",
    style: {
      fill: "#fff",
      opacity: 0.9,
      transformOrigin: "329.14px 85px"
    },
    className: "animable",
    id: "elmub4zrejdln"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.85 72.05-55.23 32a5.46 5.46 0 0 0-2.54 4.23c0 1.52 1.13 2.09 2.54 1.28l55.23-32Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "317.965px 90.9891px"
    },
    className: "animable",
    id: "elfmr5erc24q7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77 79.65a5.8 5.8 0 0 0 .43 2.35l7.65-4.43v-5.5l-7.52 4.35a10.78 10.78 0 0 0-.56 3.23Z",
    style: {
      opacity: 0.05,
      transformOrigin: "342.809px 77.035px"
    },
    className: "animable",
    id: "elkmc6z0cscka"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11 67.66c3.35-1.93 6.06-.37 6.06 3.49a13.38 13.38 0 0 1-6.06 10.49c-3.34 1.93-6.05.36-6.05-3.5a13.38 13.38 0 0 1 6.05-10.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "347.115px 74.649px"
    },
    id: "el64nyx5cgo8x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11 67.66c3.35-1.93 6.06-.37 6.06 3.49a13.38 13.38 0 0 1-6.06 10.49c-3.34 1.93-6.05.36-6.05-3.5a13.38 13.38 0 0 1 6.05-10.48Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "347.115px 74.649px"
    },
    className: "animable",
    id: "eld9qfhxxubu9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.62 125 75-43.52c1.41-.81 2.54-.24 2.54 1.28a5.43 5.43 0 0 1-2.5 4.24l-75 43.52c-1.41.81-2.54.24-2.54-1.28a5.45 5.45 0 0 1 2.5-4.24Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "329.14px 106px"
    },
    id: "elxpv097n9rw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.62 125 75-43.52c1.41-.81 2.54-.24 2.54 1.28a5.43 5.43 0 0 1-2.5 4.24l-75 43.52c-1.41.81-2.54.24-2.54-1.28a5.45 5.45 0 0 1 2.5-4.24Z",
    style: {
      fill: "#fff",
      opacity: 0.9,
      transformOrigin: "329.14px 106px"
    },
    className: "animable",
    id: "elbu8qfhqvowu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.36 113.07-20.74 12a5.45 5.45 0 0 0-2.54 4.23c0 1.52 1.13 2.09 2.54 1.28l20.74-12Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "300.72px 122.009px"
    },
    className: "animable",
    id: "el33oxee7w6h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 120.83a5.88 5.88 0 0 0 .42 2.31l7.92-4.56v-5.51l-7.76 4.48a10.7 10.7 0 0 0-.58 3.28Z",
    style: {
      opacity: 0.05,
      transformOrigin: "308.169px 118.105px"
    },
    className: "animable",
    id: "el2hl4f04p3ln"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36 108.84c3.35-1.93 6.06-.37 6.06 3.49a13.38 13.38 0 0 1-6.06 10.49c-3.34 1.93-6.05.36-6.05-3.5a13.38 13.38 0 0 1 6.05-10.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "312.365px 115.829px"
    },
    id: "elzrocfezxhrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36 108.84c3.35-1.93 6.06-.37 6.06 3.49a13.38 13.38 0 0 1-6.06 10.49c-3.34 1.93-6.05.36-6.05-3.5a13.38 13.38 0 0 1 6.05-10.48Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "312.365px 115.829px"
    },
    className: "animable",
    id: "elhrrqa8crrif"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-127",
    className: "animable",
    style: {
      transformOrigin: "191.76px 234.329px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-127",
    className: "animable",
    style: {
      transformOrigin: "191.76px 234.329px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m260.29 51.67-123.87 71.52a9.3 9.3 0 0 0-4.18 7.26v291.73c0 2.66 1.88 3.75 4.18 2.41l123.87-71.51a9.3 9.3 0 0 0 4.18-7.26V54.09c0-2.67-1.88-3.76-4.18-2.42Zm-1.85 272.55c0 2.29-1.6 3.74-3.59 4.89l-113.41 65.48c-2 1.14-3.59.22-3.59-2.07V150a7.14 7.14 0 0 1 3.58-6.19l113.42-65.57a2.39 2.39 0 0 1 3.59 2.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "198.355px 238.13px"
    },
    id: "el2381o1oa3wy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.29 51.67-123.87 71.52a9.3 9.3 0 0 0-4.18 7.26v291.73c0 2.66 1.88 3.75 4.18 2.41l123.87-71.51a9.3 9.3 0 0 0 4.18-7.26V54.09c0-2.67-1.88-3.76-4.18-2.42Zm-1.85 272.55c0 2.29-1.6 3.74-3.59 4.89l-113.41 65.48c-2 1.14-3.59.22-3.59-2.07V150a7.14 7.14 0 0 1 3.58-6.19l113.42-65.57a2.39 2.39 0 0 1 3.59 2.08Z",
    style: {
      opacity: 0.3,
      transformOrigin: "198.355px 238.13px"
    },
    className: "animable",
    id: "elrog52sqty4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44 324.22c0 2.29-1.6 3.74-3.59 4.89l-113.41 65.48c-2 1.14-3.59.22-3.59-2.07V150a7.14 7.14 0 0 1 3.58-6.19l113.42-65.57a2.39 2.39 0 0 1 3.59 2.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "198.145px 236.498px"
    },
    id: "elniu34nhs1p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44 324.22c0 2.29-1.6 3.74-3.59 4.89l-113.41 65.48c-2 1.14-3.59.22-3.59-2.07V150a7.14 7.14 0 0 1 3.58-6.19l113.42-65.57a2.39 2.39 0 0 1 3.59 2.08Z",
    style: {
      opacity: 0.5,
      transformOrigin: "198.145px 236.498px"
    },
    className: "animable",
    id: "el2cz2arj6eib"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.44 394.59 113.41-65.48a10.43 10.43 0 0 0 2.15-1.59L137.85 260.4v132.12c0 2.29 1.62 3.21 3.59 2.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "197.425px 327.739px"
    },
    id: "elgb2evwbwxmw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.44 394.59 113.41-65.48a10.43 10.43 0 0 0 2.15-1.59L137.85 260.4v132.12c0 2.29 1.62 3.21 3.59 2.07Z",
    style: {
      opacity: 0.4,
      transformOrigin: "197.425px 327.739px"
    },
    className: "animable",
    id: "el8gg4w7tafe4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26 320V81.47l-107.83 62.29a7.14 7.14 0 0 0-3.58 6.19v237.14l107.82-62.26c1.99-1.14 3.59-2.6 3.59-4.83Z",
    style: {
      fill: "#37474f",
      transformOrigin: "193.555px 234.28px"
    },
    id: "elq8okgl7u1wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.9 424.85a9.38 9.38 0 0 1-7.86-.25l-4.79-2.77a9.25 9.25 0 0 1-4.2-7.26V122.86a7.89 7.89 0 0 1 .73-3.14 10.26 10.26 0 0 1 .49-1l13.18 7.61a12.53 12.53 0 0 0-.73 1.53 7.74 7.74 0 0 0-.51 2.6v291.72c.03 2.46 1.63 3.58 3.69 2.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "127.475px 272.157px"
    },
    id: "ela172x84r46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.9 424.85a9.38 9.38 0 0 1-7.86-.25l-4.79-2.77a9.25 9.25 0 0 1-4.2-7.26V122.86a7.89 7.89 0 0 1 .73-3.14 10.26 10.26 0 0 1 .49-1l13.18 7.61a12.53 12.53 0 0 0-.73 1.53 7.74 7.74 0 0 0-.51 2.6v291.72c.03 2.46 1.63 3.58 3.69 2.67Z",
    style: {
      opacity: 0.5,
      transformOrigin: "127.475px 272.157px"
    },
    className: "animable",
    id: "ell95kqcuo0r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.05 366.11c2.68 0 3 3 3 4.3 0 4.68-3.42 10.61-7.47 12.95a6 6 0 0 1-2.89.91c-2.68 0-3-3-3-4.3 0-4.68 3.42-10.6 7.47-12.94a6 6 0 0 1 2.89-.92",
    style: {
      fill: "#b0bec5",
      transformOrigin: "198.37px 375.19px"
    },
    id: "elcnvd9nnjr5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26 92.1c1.13-.66 2.05-.13 2.05 1.18a4.52 4.52 0 0 1-2.05 3.54c-1.13.66-2 .13-2-1.18a4.51 4.51 0 0 1 2-3.54Z",
    style: {
      fill: "#263238",
      transformOrigin: "198.285px 94.46px"
    },
    id: "ela2wnkvfrjna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05 109.38c1-.58 1.81-.11 1.81 1.05a4 4 0 0 1-1.81 3.15c-1 .58-1.82.11-1.82-1a4 4 0 0 1 1.82-3.2Z",
    style: {
      fill: "#263238",
      transformOrigin: "185.045px 111.481px"
    },
    id: "elhembttuuh5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.13 105.79 20.33-11.74c1.12-.65 2-.19 2 1a4.33 4.33 0 0 1-2 3.35l-20.33 11.74c-1.12.64-2 .19-2-1a4.3 4.3 0 0 1 2-3.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "201.295px 102.093px"
    },
    id: "elh0oz8v5lr0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.43 53.43c-.3-2.18-2-3-4.14-1.76l-123.87 71.52a8.52 8.52 0 0 0-3 3.13l-13.18-7.61a8.48 8.48 0 0 1 3-3.11L247.1 44.07a9.24 9.24 0 0 1 8.38 0l4.81 2.76a9.38 9.38 0 0 1 4.14 6.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "192.335px 84.6927px"
    },
    id: "eldopypaavtsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.43 53.43c-.3-2.18-2-3-4.14-1.76l-123.87 71.52a8.52 8.52 0 0 0-3 3.13l-13.18-7.61a8.48 8.48 0 0 1 3-3.11L247.1 44.07a9.24 9.24 0 0 1 8.38 0l4.81 2.76a9.38 9.38 0 0 1 4.14 6.6Z",
    style: {
      opacity: 0.4,
      transformOrigin: "192.335px 84.6927px"
    },
    className: "animable",
    id: "eljcuw4q7lrcp"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-127",
    className: "animable",
    style: {
      transformOrigin: "236.55px 56.4068px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-127",
    className: "animable",
    style: {
      transformOrigin: "236.55px 56.4068px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.94 62.28a4.59 4.59 0 0 1-4.19.08 1.34 1.34 0 0 1-.8-1.15v-1.75a1.6 1.6 0 0 1 .94-1.26l13.28-7.67a4.62 4.62 0 0 1 4.19-.08 1.39 1.39 0 0 1 .8 1.09v1.81a1.61 1.61 0 0 1-.94 1.27Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.555px 56.4068px"
    },
    id: "elkoinzawckxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94 62.28a4.59 4.59 0 0 1-4.19.08 1.34 1.34 0 0 1-.8-1.15v-1.75a1.6 1.6 0 0 1 .94-1.26l13.28-7.67a4.62 4.62 0 0 1 4.19-.08 1.39 1.39 0 0 1 .8 1.09v1.81a1.61 1.61 0 0 1-.94 1.27Z",
    style: {
      opacity: 0.25,
      transformOrigin: "236.555px 56.4068px"
    },
    className: "animable",
    id: "elyud9xjtd0pl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.94 60.54 13.28-7.67c1.2-.69 1.26-1.77.13-2.42a4.62 4.62 0 0 0-4.19.08l-13.28 7.67c-1.2.69-1.26 1.77-.13 2.42a4.62 4.62 0 0 0 4.19-.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.55px 55.535px"
    },
    id: "el0yfhlr764xf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.94 60.54 13.28-7.67c1.2-.69 1.26-1.77.13-2.42a4.62 4.62 0 0 0-4.19.08l-13.28 7.67c-1.2.69-1.26 1.77-.13 2.42a4.62 4.62 0 0 0 4.19-.08Z",
    style: {
      opacity: 0.3,
      transformOrigin: "236.55px 55.535px"
    },
    className: "animable",
    id: "el090erddrvcj7"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "124.584px 195.508px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "124.584px 195.508px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.35 166.8a4.63 4.63 0 0 0-2-3.67 1.34 1.34 0 0 0-1.39-.11c-.25.15-1.26.71-1.52.87a1.58 1.58 0 0 0-.63 1.44v32.52a4.65 4.65 0 0 0 2 3.68 1.38 1.38 0 0 0 1.35.14c.28-.15 1.3-.74 1.57-.9a1.6 1.6 0 0 0 .63-1.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "124.584px 182.33px"
    },
    id: "elcsrksbkk8c7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35 166.8a4.63 4.63 0 0 0-2-3.67 1.34 1.34 0 0 0-1.39-.11c-.25.15-1.26.71-1.52.87a1.58 1.58 0 0 0-.63 1.44v32.52a4.65 4.65 0 0 0 2 3.68 1.38 1.38 0 0 0 1.35.14c.28-.15 1.3-.74 1.57-.9a1.6 1.6 0 0 0 .63-1.44Z",
    style: {
      opacity: 0.3,
      transformOrigin: "124.584px 182.33px"
    },
    className: "animable",
    id: "elchl7dmpwq2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83 167.68v32.52c0 1.38-.9 2-2 1.33a4.65 4.65 0 0 1-2-3.68v-32.52c0-1.38.91-2 2-1.33a4.66 4.66 0 0 1 2 3.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "123.83px 182.765px"
    },
    id: "ela6clk9w981b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83 167.68v32.52c0 1.38-.9 2-2 1.33a4.65 4.65 0 0 1-2-3.68v-32.52c0-1.38.91-2 2-1.33a4.66 4.66 0 0 1 2 3.68Z",
    style: {
      opacity: 0.4,
      transformOrigin: "123.83px 182.765px"
    },
    className: "animable",
    id: "elbw8jf3twyo4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35 210.34a4.61 4.61 0 0 0-2-3.67 1.32 1.32 0 0 0-1.39-.12c-.25.16-1.26.71-1.52.87a1.61 1.61 0 0 0-.63 1.45v15.33a4.65 4.65 0 0 0 2 3.67 1.38 1.38 0 0 0 1.35.14c.28-.14 1.3-.74 1.57-.89a1.62 1.62 0 0 0 .63-1.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "124.585px 217.266px"
    },
    id: "elwicpc1xwc7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35 210.34a4.61 4.61 0 0 0-2-3.67 1.32 1.32 0 0 0-1.39-.12c-.25.16-1.26.71-1.52.87a1.61 1.61 0 0 0-.63 1.45v15.33a4.65 4.65 0 0 0 2 3.67 1.38 1.38 0 0 0 1.35.14c.28-.14 1.3-.74 1.57-.89a1.62 1.62 0 0 0 .63-1.45Z",
    style: {
      opacity: 0.3,
      transformOrigin: "124.585px 217.266px"
    },
    className: "animable",
    id: "elv3yvkr7fqk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83 211.21v15.33c0 1.38-.9 2-2 1.33a4.65 4.65 0 0 1-2-3.67v-15.33c0-1.39.91-2 2-1.33a4.65 4.65 0 0 1 2 3.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "123.83px 217.704px"
    },
    id: "elmpdwx2bwbrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83 211.21v15.33c0 1.38-.9 2-2 1.33a4.65 4.65 0 0 1-2-3.67v-15.33c0-1.39.91-2 2-1.33a4.65 4.65 0 0 1 2 3.67Z",
    style: {
      opacity: 0.4,
      transformOrigin: "123.83px 217.704px"
    },
    className: "animable",
    id: "elvoqrzajng0d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-127",
    className: "animable animator-active",
    style: {
      transformOrigin: "214.915px 245.513px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m268.75 86.55-114.45 66a5.68 5.68 0 0 0-2.58 4.46v242.12a5.64 5.64 0 0 0 2.58 4.45l1.61.92a5.72 5.72 0 0 0 5.16 0l114.46-66.1a5.69 5.69 0 0 0 2.57-4.46v-242a5.64 5.64 0 0 0-2.58-4.45l-1.61-.92a5.69 5.69 0 0 0-5.16-.02Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "214.91px 245.528px"
    },
    id: "eldi5g1nx57ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1 334.11c0 2.27-1.59 3.71-3.56 4.84l-112.49 65c-2 1.13-3.56.22-3.56-2.06V162a7.06 7.06 0 0 1 3.55-6.14l112.5-65a2.38 2.38 0 0 1 3.56 2.06Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "218.295px 247.491px"
    },
    id: "el8k2u2pwnr52",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47 196v205.81c0 2.28 1.6 3.19 3.56 2.06l112.49-65c2-1.13 3.56-2.57 3.56-4.84V126.9Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "218.275px 265.627px"
    },
    id: "ellbcc06v7ybp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.72 91.54a1.39 1.39 0 0 1 1.39 1.39v241.18c0 1.54-.94 2.77-3.06 4l-112.49 64.94a2.3 2.3 0 0 1-1.1.35c-.85 0-1-1-1-1.55V162a6.14 6.14 0 0 1 3.05-5.29l112.5-65a1.33 1.33 0 0 1 .69-.19m0-1a2.36 2.36 0 0 0-1.18.32l-112.5 65a7.06 7.06 0 0 0-3.55 6.14v239.87c0 1.61.81 2.54 2 2.54a3.21 3.21 0 0 0 1.59-.48l112.49-65c2-1.13 3.56-2.57 3.56-4.84V92.93a2.38 2.38 0 0 0-2.38-2.38Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "218.29px 247.455px"
    },
    id: "eltk1btsttiz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1 91.91v1a2.38 2.38 0 0 0-3.57-2L162 155.86a6.78 6.78 0 0 0-2.59 2.59.3.3 0 0 0 0 .08l-7-4a5.25 5.25 0 0 1 1.86-2l114.45-66a5.69 5.69 0 0 1 5.16 0l1.61.92a5.67 5.67 0 0 1 2.61 4.46Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "215.255px 122.221px"
    },
    id: "el7267mhi5nef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "189.39px 189.778px"
    },
    className: "animable",
    id: "elly1lxeazuy8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.39 199 40-23.1c1.19-.69 2.15-.2 2.15 1.08a4.6 4.6 0 0 1-2.15 3.57l-40 23.11c-1.19.68-2.15.2-2.15-1.09a4.62 4.62 0 0 1 2.15-3.57Z",
    id: "el7lnbpucxamd",
    className: "animable",
    style: {
      transformOrigin: "189.39px 189.778px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "185.175px 208.545px"
    },
    className: "animable",
    id: "elwr1qp86mnf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 213 23.53-13.56c1.19-.69 2.15-.2 2.15 1.08a4.6 4.6 0 0 1-2.15 3.57l-23.53 13.56c-1.19.69-2.15.2-2.15-1.08a4.6 4.6 0 0 1 2.15-3.57Z",
    id: "elsqc8je45pu8",
    className: "animable",
    style: {
      transformOrigin: "185.175px 208.545px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 210.07a.49.49 0 0 1-.43-.24.51.51 0 0 1 .18-.68l104.76-60.48a.49.49 0 0 1 .68.18.51.51 0 0 1-.19.68L167.49 210a.54.54 0 0 1-.25.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.619px 179.335px"
    },
    id: "elhxpqbwt76uj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 228.67a.49.49 0 0 1-.25-.92l104.76-60.48a.49.49 0 0 1 .68.18.51.51 0 0 1-.19.68l-104.75 60.48a.54.54 0 0 1-.25.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.613px 197.935px"
    },
    id: "el0992gnvx5tc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24 165.34c1-.58 1.82-.11 1.82 1a4 4 0 0 1-1.83 3.14c-1 .58-1.83.1-1.82-1.05a4 4 0 0 1 1.83-3.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "256.235px 167.408px"
    },
    id: "el2bhpbtibc2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05 171.28a1.89 1.89 0 0 1-.94-.25 2.21 2.21 0 0 1-1-2 6.67 6.67 0 0 1 3.13-5.22l6.15-3.57a2.49 2.49 0 0 1 2.51-.23 2.22 2.22 0 0 1 1 2 6.64 6.64 0 0 1-3.14 5.22l-6.12 3.57a3.15 3.15 0 0 1-1.59.48ZM253.8 169a1.61 1.61 0 0 0 .65 1.45 1.89 1.89 0 0 0 1.82-.23l6.13-3.57a6 6 0 0 0 2.8-4.63 1.55 1.55 0 0 0-.64-1.44 1.86 1.86 0 0 0-1.82.23l-6.15 3.56a6 6 0 0 0-2.79 4.63Z",
    style: {
      fill: "#455a64",
      transformOrigin: "259.505px 165.527px"
    },
    id: "elxqxwba27l8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "191.41px 223.542px"
    },
    className: "animable",
    id: "elb1h06pieqxs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 231.61 36-20.79c1.19-.69 2.15-.2 2.15 1.09a4.59 4.59 0 0 1-2.15 3.56l-36 20.8c-1.19.68-2.15.19-2.15-1.09a4.6 4.6 0 0 1 2.15-3.57Z",
    id: "elhi52ghrwteh",
    className: "animable",
    style: {
      transformOrigin: "191.41px 223.542px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 247.26a.49.49 0 0 1-.43-.24.51.51 0 0 1 .18-.68l104.76-60.48a.49.49 0 0 1 .68.18.51.51 0 0 1-.19.68L167.49 247.2a.54.54 0 0 1-.25.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.619px 216.525px"
    },
    id: "elb79dyehqjgj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05 189.87a1.79 1.79 0 0 1-.94-.25 2.2 2.2 0 0 1-1-2 6.67 6.67 0 0 1 3.13-5.23l6.15-3.56a2.48 2.48 0 0 1 2.51-.24 2.22 2.22 0 0 1 1 2 6.64 6.64 0 0 1-3.14 5.22l-6.12 3.57a3.15 3.15 0 0 1-1.59.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "259.505px 184.113px"
    },
    id: "elp769cbvo32h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82 180.08c1-.58 1.82-.11 1.82 1a4 4 0 0 1-1.83 3.14c-1 .58-1.82.1-1.82-1.05a4.07 4.07 0 0 1 1.83-3.09Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "262.815px 182.148px"
    },
    id: "elg9oeew5lltm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05 227.05a1.88 1.88 0 0 1-.94-.24 2.23 2.23 0 0 1-1-2 6.67 6.67 0 0 1 3.13-5.23l6.16-3.58a2.47 2.47 0 0 1 2.51-.23 2.19 2.19 0 0 1 1 2 6.64 6.64 0 0 1-3.14 5.22l-6.12 3.57a3.15 3.15 0 0 1-1.6.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "259.511px 221.29px"
    },
    id: "ely81xd94appe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82 217.26c1-.58 1.82-.11 1.82 1.06a4 4 0 0 1-1.83 3.14c-1 .57-1.82.1-1.82-1.06a4.08 4.08 0 0 1 1.83-3.14Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "262.815px 219.357px"
    },
    id: "elt099vrp5ub8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05 245.64a1.88 1.88 0 0 1-.94-.24 2.23 2.23 0 0 1-1-2 6.69 6.69 0 0 1 3.13-5.23l6.15-3.56a2.49 2.49 0 0 1 2.51-.23 2.19 2.19 0 0 1 1 2 6.67 6.67 0 0 1-3.14 5.23l-6.12 3.56a3.15 3.15 0 0 1-1.59.47Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "259.506px 239.892px"
    },
    id: "elwf3ir1zou1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82 235.86c1-.59 1.82-.11 1.82 1a4 4 0 0 1-1.83 3.14c-1 .57-1.82.1-1.82-1.05a4.05 4.05 0 0 1 1.83-3.09Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "262.815px 237.924px"
    },
    id: "elyvu99e2umwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "185.175px 245.747px"
    },
    className: "animable",
    id: "elvdqyqjvb2ds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 250.2 23.53-13.56c1.19-.69 2.15-.2 2.15 1.09a4.59 4.59 0 0 1-2.15 3.56l-23.53 13.57c-1.19.68-2.15.19-2.15-1.09a4.62 4.62 0 0 1 2.15-3.57Z",
    id: "el9egalsm8yek",
    className: "animable",
    style: {
      transformOrigin: "185.175px 245.747px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 265.86a.5.5 0 0 1-.43-.25.51.51 0 0 1 .18-.68l104.76-60.48a.49.49 0 0 1 .68.18.51.51 0 0 1-.19.68l-104.75 60.48a.55.55 0 0 1-.25.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.619px 235.12px"
    },
    id: "els4sp3nkpnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24 202.52c1-.58 1.82-.11 1.82 1.06a4 4 0 0 1-1.83 3.14c-1 .57-1.83.1-1.82-1.06a4 4 0 0 1 1.83-3.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "256.235px 204.617px"
    },
    id: "el9yi6e9iqe1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05 208.46a1.88 1.88 0 0 1-.94-.24 2.23 2.23 0 0 1-1-2 6.67 6.67 0 0 1 3.13-5.23l6.15-3.56a2.45 2.45 0 0 1 2.51-.23 2.19 2.19 0 0 1 1 2 6.64 6.64 0 0 1-3.14 5.22l-6.14 3.58a3.15 3.15 0 0 1-1.57.46Zm-1.25-2.29a1.61 1.61 0 0 0 .65 1.45 1.86 1.86 0 0 0 1.82-.23l6.13-3.57a6 6 0 0 0 2.8-4.63 1.57 1.57 0 0 0-.64-1.44 1.86 1.86 0 0 0-1.82.23l-6.15 3.56a6 6 0 0 0-2.79 4.63Z",
    style: {
      fill: "#455a64",
      transformOrigin: "259.506px 202.709px"
    },
    id: "elpi8c1v32vy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "189.405px 261.906px"
    },
    className: "animable",
    id: "elajpwe2p6cde"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 268.8 32-18.44c1.18-.68 2.14-.19 2.14 1.09a4.64 4.64 0 0 1-2.14 3.57l-32 18.43c-1.19.68-2.15.2-2.15-1.09a4.59 4.59 0 0 1 2.15-3.56Z",
    id: "el0xxfzm8oy3cf",
    className: "animable",
    style: {
      transformOrigin: "189.405px 261.906px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 284.45a.5.5 0 0 1-.43-.25.51.51 0 0 1 .18-.68L271.75 223a.49.49 0 0 1 .68.18.51.51 0 0 1-.19.68l-104.75 60.52a.45.45 0 0 1-.25.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.619px 253.69px"
    },
    id: "elaqgsb61yy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "185.175px 282.91px"
    },
    className: "animable",
    id: "el4bnadnp2jiq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 287.39 23.53-13.57c1.19-.68 2.15-.2 2.15 1.09a4.59 4.59 0 0 1-2.15 3.56L173.41 292c-1.19.68-2.15.2-2.15-1.09a4.59 4.59 0 0 1 2.15-3.52Z",
    id: "elcwgg47rpzf",
    className: "animable",
    style: {
      transformOrigin: "185.175px 282.91px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "189.39px 301.483px"
    },
    className: "animable",
    id: "elycye8bwth1o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.39 310.71 40-23.11c1.19-.68 2.15-.19 2.15 1.09a4.6 4.6 0 0 1-2.15 3.57l-40 23.1c-1.19.69-2.15.2-2.15-1.08a4.6 4.6 0 0 1 2.15-3.57Z",
    id: "elahkup42pfdk",
    className: "animable",
    style: {
      transformOrigin: "189.39px 301.483px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "195.44px 314.283px"
    },
    className: "animable",
    id: "el4f59jz68ltr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 324.7 44.06-25.49c1.19-.68 2.15-.19 2.15 1.09a4.62 4.62 0 0 1-2.15 3.57l-44.06 25.48c-1.19.69-2.15.2-2.15-1.08a4.59 4.59 0 0 1 2.15-3.57Z",
    id: "elxch94a9w1a",
    className: "animable",
    style: {
      transformOrigin: "195.44px 314.283px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 321.75a.49.49 0 0 1-.25-.92l104.76-60.48a.49.49 0 0 1 .68.18.51.51 0 0 1-.19.68l-104.75 60.48a.54.54 0 0 1-.25.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.613px 291.015px"
    },
    id: "el1qg7vtypax6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 340.35a.49.49 0 0 1-.25-.92L271.75 279a.49.49 0 1 1 .49.85l-104.75 60.43a.45.45 0 0 1-.25.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "219.61px 309.642px"
    },
    id: "eld6njyo5vx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "191.41px 335.22px"
    },
    className: "animable",
    id: "elujrth4ns1is"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 343.29 36-20.79c1.19-.69 2.15-.2 2.15 1.08a4.6 4.6 0 0 1-2.15 3.57l-36 20.79c-1.19.69-2.15.2-2.15-1.08a4.6 4.6 0 0 1 2.15-3.57Z",
    id: "ellofperaq4t",
    className: "animable",
    style: {
      transformOrigin: "191.41px 335.22px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m242.29 284.86 21.41-12.34c1.19-.68 2.15-.2 2.15 1.09a4.59 4.59 0 0 1-2.15 3.56l-21.41 12.35c-1.18.68-2.15.2-2.15-1.09a4.65 4.65 0 0 1 2.15-3.57Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "252.995px 281.02px"
    },
    id: "elrsqlpp4il1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 271.17a.35.35 0 0 1-.1-.08.21.21 0 0 1-.06-.17v-.67a.35.35 0 0 1 0-.14.24.24 0 0 1 .08-.09h.08l1.79.83a.23.23 0 0 1 .11.07.25.25 0 0 1 0 .17v.33a.48.48 0 0 1 0 .22.81.81 0 0 1-.11.2l-1.79 2.88a.08.08 0 0 1-.08 0 .13.13 0 0 1 0-.1V274a.53.53 0 0 1 .06-.23 2.09 2.09 0 0 1 .1-.21l1.16-1.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "268.874px 272.375px"
    },
    id: "elu4u2fwyngln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.29 303.47 21.41-12.34c1.19-.68 2.15-.2 2.15 1.09a4.59 4.59 0 0 1-2.15 3.56l-21.41 12.35c-1.18.68-2.15.19-2.15-1.09a4.65 4.65 0 0 1 2.15-3.57Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "252.995px 299.629px"
    },
    id: "eliuhxwb32vu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 289.78a.35.35 0 0 1-.1-.08.21.21 0 0 1-.06-.17v-.67a.35.35 0 0 1 0-.14.24.24 0 0 1 .08-.09h.08l1.79.83a.23.23 0 0 1 .11.07.25.25 0 0 1 0 .17v.3a.48.48 0 0 1 0 .22.81.81 0 0 1-.11.2l-1.79 2.91a.08.08 0 0 1-.08 0 .13.13 0 0 1 0-.1v-.67a.49.49 0 0 1 .06-.23 2.09 2.09 0 0 1 .1-.21l1.16-1.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "268.874px 290.985px"
    },
    id: "elsl73j02avkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46 383.59a1.63 1.63 0 0 1-.81-.21 2 2 0 0 1-.87-1.82v-9a5.2 5.2 0 0 1 2.39-4.14l27.94-16.13A1.79 1.79 0 0 1 204 354v9a5.22 5.22 0 0 1-2.39 4.15l-27.94 16.13a2.46 2.46 0 0 1-1.21.31Zm29.86-30.67a1.52 1.52 0 0 0-.71.22l-27.94 16.13a4.28 4.28 0 0 0-1.9 3.29v9a1.07 1.07 0 0 0 .38 1 1.05 1.05 0 0 0 1-.15l27.94-16.13A4.26 4.26 0 0 0 203 363v-9a1.07 1.07 0 0 0-.38-1 .64.64 0 0 0-.3-.08Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "187.401px 367.74px"
    },
    id: "elr3is9bg95z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.74 371.33a2.1 2.1 0 0 0 0 .27v.7a1.86 1.86 0 0 0 0 .26 2.43 2.43 0 0 0 0 .3.51.51 0 0 0 .1.21.26.26 0 0 0 .19.08.6.6 0 0 0 .27-.09 1.09 1.09 0 0 0 .26-.21 1.18 1.18 0 0 0 .17-.24.77.77 0 0 0 .1-.25 1 1 0 0 0 .06-.22.64.64 0 0 1 0-.19.29.29 0 0 1 .11-.11l.62-.36h.07a.12.12 0 0 1 0 .09 3 3 0 0 1-.11.77 3.53 3.53 0 0 1-.32.75 3.8 3.8 0 0 1-.46.65 2.55 2.55 0 0 1-.58.48 1.16 1.16 0 0 1-.61.19.68.68 0 0 1-.46-.16 1 1 0 0 1-.29-.46 2.37 2.37 0 0 1-.12-.7v-1.3a4 4 0 0 1 .26-.79 3.63 3.63 0 0 1 .29-.8 2.74 2.74 0 0 1 .45-.69 2.31 2.31 0 0 1 .62-.51 1.3 1.3 0 0 1 .58-.2.72.72 0 0 1 .46.12.81.81 0 0 1 .32.38 1.75 1.75 0 0 1 .11.64.35.35 0 0 1 0 .13.22.22 0 0 1-.07.09l-.62.36h-.11a.23.23 0 0 1 0-.13.52.52 0 0 0-.06-.16.22.22 0 0 0-.1-.13.29.29 0 0 0-.17 0 .54.54 0 0 0-.26.09.87.87 0 0 0-.27.23 1.12 1.12 0 0 0-.19.29 1.59 1.59 0 0 0-.1.33c-.12.06-.13.18-.14.29Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "180.288px 371.604px"
    },
    id: "ellik13tb0xib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32 371.93a2 2 0 0 1 .24-.93 3.16 3.16 0 0 1 .78-.91l.56-.47a.39.39 0 0 0-.07-.25c0-.05-.11-.05-.21 0a.61.61 0 0 0-.17.14.53.53 0 0 0-.08.14l-.09.12-.09.06-.6.35a.06.06 0 0 1-.08 0s0-.05 0-.1a1.4 1.4 0 0 1 .09-.4 2.69 2.69 0 0 1 .24-.48 3.5 3.5 0 0 1 .35-.46 2.54 2.54 0 0 1 .45-.36 1.22 1.22 0 0 1 .5-.18.53.53 0 0 1 .36.1.67.67 0 0 1 .2.34 1.79 1.79 0 0 1 .07.55v2.21a.29.29 0 0 1 0 .16.17.17 0 0 1-.09.11l-.6.35a.06.06 0 0 1-.09 0 .16.16 0 0 1 0-.11v-.21a2.11 2.11 0 0 1-.29.51 1.36 1.36 0 0 1-.44.38.93.93 0 0 1-.36.13.4.4 0 0 1-.27-.09.59.59 0 0 1-.16-.27 1.35 1.35 0 0 1-.15-.43Zm1.08-.46a.74.74 0 0 0 .2-.16 1 1 0 0 0 .15-.24 1.62 1.62 0 0 0 .11-.28 1.54 1.54 0 0 0 0-.3l-.44.35a1.21 1.21 0 0 0-.21.25.54.54 0 0 0-.07.27v.16a.22.22 0 0 0 .26-.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "183.551px 370.459px"
    },
    id: "eldcz92eflaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 369.51a.29.29 0 0 1 0 .16.26.26 0 0 1-.09.11l-.6.35a.06.06 0 0 1-.09 0 .16.16 0 0 1 0-.11v-1.85a.83.83 0 0 0-.1-.45c-.07-.09-.17-.09-.32 0a.81.81 0 0 0-.31.37 1.64 1.64 0 0 0-.09.56v1.85a.47.47 0 0 1 0 .16.35.35 0 0 1-.09.11l-.6.34h-.09a.19.19 0 0 1 0-.12v-3.4a.47.47 0 0 1 0-.16.35.35 0 0 1 .09-.11l.57-.33h.09a.12.12 0 0 1 0 .11v.17l.1-.21a1.27 1.27 0 0 1 .13-.22l.19-.21a1.14 1.14 0 0 1 .25-.18 1 1 0 0 1 .42-.15.47.47 0 0 1 .32.12.8.8 0 0 1 .21.39 2.72 2.72 0 0 1 .08.71Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "186.84px 368.705px"
    },
    id: "el628ezeqnvlw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55 366.68v.51a.5.5 0 0 0 .13.35.27.27 0 0 0 .31 0 .83.83 0 0 0 .24-.21 1.13 1.13 0 0 0 .13-.27.52.52 0 0 1 .06-.13.16.16 0 0 1 .08-.1l.62-.36a.08.08 0 0 1 .09 0s0 .06 0 .12 0 .2-.06.38a3.18 3.18 0 0 1-.2.56 3.46 3.46 0 0 1-.39.61 2.24 2.24 0 0 1-.61.52 1.24 1.24 0 0 1-.5.17.61.61 0 0 1-.4-.11.73.73 0 0 1-.28-.37 1.78 1.78 0 0 1-.11-.63v-.58a3.17 3.17 0 0 1 .11-.76 3 3 0 0 1 .28-.69 2.91 2.91 0 0 1 .4-.57 1.87 1.87 0 0 1 .5-.4 1 1 0 0 1 .61-.19.63.63 0 0 1 .39.16.86.86 0 0 1 .2.33c0 .13.05.24.06.31a.32.32 0 0 1 0 .16.26.26 0 0 1-.09.11l-.62.36h-.08a.2.2 0 0 1-.06-.07.19.19 0 0 0-.13-.12.37.37 0 0 0-.24.07.77.77 0 0 0-.31.33 1.42 1.42 0 0 0-.13.51Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.94px 366.681px"
    },
    id: "elv79l8r5amjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.63 365.58a.57.57 0 0 0 0 .25.25.25 0 0 0 .1.12.23.23 0 0 0 .14 0 .47.47 0 0 0 .15-.06 1.05 1.05 0 0 0 .22-.17.77.77 0 0 0 .14-.21l.08-.13a.18.18 0 0 1 .08-.06l.62-.36c.07 0 .1 0 .1.1a1.11 1.11 0 0 1-.07.31 2.88 2.88 0 0 1-.22.49 2.78 2.78 0 0 1-.39.55 1.92 1.92 0 0 1-.56.46 1.29 1.29 0 0 1-.55.19.54.54 0 0 1-.4-.16 1.09 1.09 0 0 1-.25-.48 3.4 3.4 0 0 1-.08-.78 4.58 4.58 0 0 1 .08-.83 3.85 3.85 0 0 1 .25-.77 3 3 0 0 1 .4-.64 2.05 2.05 0 0 1 .55-.47 1 1 0 0 1 .59-.16.67.67 0 0 1 .4.24 1.33 1.33 0 0 1 .22.51 3.51 3.51 0 0 1 .07.66v.2a.53.53 0 0 1 0 .17.35.35 0 0 1-.09.11Zm.43-1.65a.79.79 0 0 0-.31.36 1.41 1.41 0 0 0-.12.48l.85-.5a.55.55 0 0 0-.12-.33c-.07-.08-.17-.09-.3-.01Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "193.023px 364.915px"
    },
    id: "elanxcqsat6dd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86 365a.34.34 0 0 1 0 .16.2.2 0 0 1-.09.11l-.6.34a.08.08 0 0 1-.09 0 .21.21 0 0 1 0-.12v-4.79a.5.5 0 0 1 0-.16.35.35 0 0 1 .09-.11l.6-.34h.09a.16.16 0 0 1 0 .12Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "195.471px 362.857px"
    },
    id: "elperudkycye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69 343.23v-9a4.75 4.75 0 0 1 2.15-3.72l27.93-16.13c1.19-.68 2.15-.13 2.15 1.24v9a4.73 4.73 0 0 1-2.15 3.72l-27.93 16.13c-1.19.69-2.15.13-2.15-1.24Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "253.805px 329.427px"
    },
    id: "eljn227t5gaaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.59 329.66h.14a.33.33 0 0 1 .07.13l1 4a.18.18 0 0 1 0 .09.35.35 0 0 1 0 .14.22.22 0 0 1-.07.09l-.6.34H249a.14.14 0 0 1-.05-.09l-.14-.53-1.26.72-.13.69a.65.65 0 0 1-.05.15.37.37 0 0 1-.14.14l-.59.34a.08.08 0 0 1-.08 0 .15.15 0 0 1 0-.1v-.12l1-5.2a.82.82 0 0 1 .06-.19.36.36 0 0 1 .15-.17Zm-.77 3.63.77-.44-.39-1.53Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "248.179px 332.77px"
    },
    id: "el1qo71sk0gaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.91 332.92a.68.68 0 0 1-.25.1.35.35 0 0 1-.18 0 .19.19 0 0 1-.12-.07.38.38 0 0 1-.09-.09v1.56a.34.34 0 0 1 0 .16.2.2 0 0 1-.09.11l-.6.34a.07.07 0 0 1-.09 0 .21.21 0 0 1 0-.12v-4.79a.5.5 0 0 1 0-.16.35.35 0 0 1 .09-.11l.58-.33a.06.06 0 0 1 .09 0 .16.16 0 0 1 0 .11v.17a1.65 1.65 0 0 1 .09-.21 1.13 1.13 0 0 1 .12-.21 1.68 1.68 0 0 1 .18-.21 1.57 1.57 0 0 1 .27-.19.94.94 0 0 1 .4-.13.46.46 0 0 1 .33.11 1 1 0 0 1 .23.39 2.53 2.53 0 0 1 .1.69v.59a3.89 3.89 0 0 1-.1.8 3.64 3.64 0 0 1-.23.66 2.71 2.71 0 0 1-.33.5 1.71 1.71 0 0 1-.4.33Zm.21-1.89a2.67 2.67 0 0 0 0-.4.79.79 0 0 0-.11-.39c-.06-.09-.17-.09-.32 0a.65.65 0 0 0-.18.15.88.88 0 0 0-.12.21 1 1 0 0 0-.08.23 2.23 2.23 0 0 0 0 .23 2.17 2.17 0 0 0 0 .26 1.78 1.78 0 0 0 0 .25.9.9 0 0 0 0 .19.36.36 0 0 0 .08.15.23.23 0 0 0 .12.06.35.35 0 0 0 .18-.05.74.74 0 0 0 .32-.38 1.72 1.72 0 0 0 .11-.54Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "251.726px 331.948px"
    },
    id: "elqh4xh244gt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.15 331.05a.92.92 0 0 1-.25.1.36.36 0 0 1-.18 0 .24.24 0 0 1-.12-.07l-.09-.09v1.56a.34.34 0 0 1 0 .16.2.2 0 0 1-.09.11l-.59.34h-.09a.12.12 0 0 1 0-.11v-4.79a.32.32 0 0 1 0-.16.2.2 0 0 1 .09-.11l.57-.33a.06.06 0 0 1 .09 0 .16.16 0 0 1 0 .11v.17l.09-.21a1.13 1.13 0 0 1 .12-.21 1.68 1.68 0 0 1 .18-.21 1.57 1.57 0 0 1 .27-.19.82.82 0 0 1 .4-.13.43.43 0 0 1 .33.11.92.92 0 0 1 .23.39 2.53 2.53 0 0 1 .1.69v.59a3.89 3.89 0 0 1-.1.8 3.2 3.2 0 0 1-.23.66 2 2 0 0 1-.33.5 1.71 1.71 0 0 1-.4.32Zm.21-1.89a2.8 2.8 0 0 0 0-.41.78.78 0 0 0-.11-.38c-.06-.09-.17-.09-.32 0a.65.65 0 0 0-.18.15.72.72 0 0 0-.12.21.9.9 0 0 0-.08.23 2.23 2.23 0 0 0 0 .23 2.17 2.17 0 0 0 0 .26 1.85 1.85 0 0 0 0 .25.9.9 0 0 0 0 .19.27.27 0 0 0 .08.14.19.19 0 0 0 .12.07.29.29 0 0 0 .18-.06.69.69 0 0 0 .32-.37 1.72 1.72 0 0 0 .11-.51Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "254.968px 330.074px"
    },
    id: "el3ay1lhqcj4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75 329.28a.5.5 0 0 1 0 .16.35.35 0 0 1-.09.11l-.6.34h-.09a.16.16 0 0 1 0-.12V325a.32.32 0 0 1 0-.16.2.2 0 0 1 .09-.11l.6-.34a.07.07 0 0 1 .09 0 .21.21 0 0 1 0 .12Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "257.359px 327.132px"
    },
    id: "ell1u4lmbbqqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82 329.49a.43.43 0 0 1 0 .14.17.17 0 0 1-.09.11l-.62.36h-.08a.12.12 0 0 1 0-.11.09.09 0 0 1 0-.05l.36-1.52-1-2.86v-.05a.42.42 0 0 1 0-.15.18.18 0 0 1 .08-.09l.62-.36h.09a.41.41 0 0 1 .05.09l.52 1.6.53-2.2a.48.48 0 0 1 0-.15.33.33 0 0 1 .09-.11l.63-.36a.06.06 0 0 1 .08 0 .13.13 0 0 1 0 .1v.12Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "259.737px 326.932px"
    },
    id: "elxzfy14pxls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.07 156.45c.41-.24.73-.27 1-.1s.34.54.34 1.12A3.21 3.21 0 0 1 206 159a2.49 2.49 0 0 1-1 1l-.83.47v1.76a.35.35 0 0 1 0 .17.24.24 0 0 1-.09.12l-.42.24a.09.09 0 0 1-.1 0 .22.22 0 0 1 0-.13v-5.1a.47.47 0 0 1 0-.17.25.25 0 0 1 .1-.12Zm-.83 3 .8-.46a1.2 1.2 0 0 0 .64-1.16c0-.3-.06-.47-.17-.52a.59.59 0 0 0-.47.1l-.8.46Z",
    style: {
      fill: "#455a64",
      transformOrigin: "204.98px 159.509px"
    },
    id: "ele1wqpi7nxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13 157.05a1 1 0 0 0-.44.47 1.78 1.78 0 0 0-.14.76v2.05a.33.33 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.23a.06.06 0 0 1-.09 0 .17.17 0 0 1 0-.13V157a.39.39 0 0 1 0-.18.24.24 0 0 1 .09-.12l.39-.22a.08.08 0 0 1 .1 0s0 .06 0 .12v.18a2.33 2.33 0 0 1 .29-.45 1.45 1.45 0 0 1 .39-.34l.23-.13a.08.08 0 0 1 .1 0 .15.15 0 0 1 0 .12v.53a.38.38 0 0 1 0 .17.25.25 0 0 1-.1.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "207.765px 158.356px"
    },
    id: "elm7xf35f0icg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85 157.74a4.48 4.48 0 0 1 .09-.89 4.34 4.34 0 0 1 .25-.82 3 3 0 0 1 .4-.68 1.9 1.9 0 0 1 .52-.47.93.93 0 0 1 .52-.14.63.63 0 0 1 .4.21 1.19 1.19 0 0 1 .25.49 2.63 2.63 0 0 1 .09.72v.35a.39.39 0 0 1 0 .18.25.25 0 0 1-.1.12l-1.71 1a.79.79 0 0 0 0 .29.32.32 0 0 0 .13.15.25.25 0 0 0 .19 0 .65.65 0 0 0 .22-.08 1.2 1.2 0 0 0 .27-.21 1.24 1.24 0 0 0 .17-.23.56.56 0 0 1 .09-.14.44.44 0 0 1 .1-.08l.41-.23a.09.09 0 0 1 .1 0 .14.14 0 0 1 0 .13 1.4 1.4 0 0 1-.07.33 2.87 2.87 0 0 1-.23.47 3.24 3.24 0 0 1-.36.49 2 2 0 0 1-.51.41.93.93 0 0 1-.52.15.55.55 0 0 1-.4-.21 1.25 1.25 0 0 1-.25-.53 3.18 3.18 0 0 1-.05-.78Zm1.26-1.91a1 1 0 0 0-.25.21 1.67 1.67 0 0 0-.18.28 1.82 1.82 0 0 0-.11.3 1.51 1.51 0 0 0 0 .28l1.16-.67a1.85 1.85 0 0 0 0-.23.38.38 0 0 0-.09-.18.21.21 0 0 0-.17-.08.6.6 0 0 0-.36.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "210.112px 157px"
    },
    id: "eltxhxn3wc78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.81 153.4.71-.41a.08.08 0 0 1 .1 0 .15.15 0 0 1 0 .12v.52a.39.39 0 0 1 0 .18.25.25 0 0 1-.1.12l-.71.41v2.94a.39.39 0 0 1 0 .18.4.4 0 0 1-.1.12l-.39.22a.06.06 0 0 1-.09 0s0-.06 0-.12v-3l-.34.2a.08.08 0 0 1-.1 0 .15.15 0 0 1 0-.12v-.53a.38.38 0 0 1 0-.17.25.25 0 0 1 .1-.12l.34-.19v-.36a2.84 2.84 0 0 1 .07-.68 1.79 1.79 0 0 1 .2-.55 1.94 1.94 0 0 1 .32-.42 2.59 2.59 0 0 1 .42-.32l.42-.24a.06.06 0 0 1 .09 0 .17.17 0 0 1 0 .13v.52a.35.35 0 0 1 0 .17.24.24 0 0 1-.09.12l-.37.21a.78.78 0 0 0-.29.28.88.88 0 0 0-.11.47Z",
    style: {
      fill: "#455a64",
      transformOrigin: "212.77px 154.49px"
    },
    id: "elyqyhb48eyaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.92 154.81a4.38 4.38 0 0 1 .09-.88 4.23 4.23 0 0 1 .25-.83 3 3 0 0 1 .4-.68 1.85 1.85 0 0 1 .52-.46.79.79 0 0 1 .52-.14.57.57 0 0 1 .4.2 1.19 1.19 0 0 1 .25.49 2.63 2.63 0 0 1 .09.72v.36a.38.38 0 0 1 0 .17.25.25 0 0 1-.1.12l-1.71 1a.76.76 0 0 0 0 .29.35.35 0 0 0 .13.16.3.3 0 0 0 .19 0 .65.65 0 0 0 .22-.08 1.18 1.18 0 0 0 .27-.2 1.7 1.7 0 0 0 .17-.23.42.42 0 0 1 .09-.14.21.21 0 0 1 .1-.08l.41-.24a.08.08 0 0 1 .1 0s0 .06 0 .12a1.4 1.4 0 0 1-.07.33 2.53 2.53 0 0 1-.23.47 3.31 3.31 0 0 1-.36.5 2.24 2.24 0 0 1-.51.41.84.84 0 0 1-.52.14.55.55 0 0 1-.4-.21 1.26 1.26 0 0 1-.25-.52 3.26 3.26 0 0 1-.05-.79Zm1.26-1.91a.88.88 0 0 0-.25.22 1.27 1.27 0 0 0-.18.27 1.82 1.82 0 0 0-.11.3 1.66 1.66 0 0 0 0 .28l1.16-.67a1.85 1.85 0 0 0 0-.23.51.51 0 0 0-.09-.18.25.25 0 0 0-.17-.08.6.6 0 0 0-.36.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "215.182px 154.074px"
    },
    id: "elm3bbvsmvm3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.25 151.21a1 1 0 0 0-.45.47 1.79 1.79 0 0 0-.13.76v2.05a.47.47 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.23a.08.08 0 0 1-.1 0 .17.17 0 0 1 0-.13v-3.68a.39.39 0 0 1 0-.18.25.25 0 0 1 .1-.12l.39-.22a.08.08 0 0 1 .1 0 .17.17 0 0 1 0 .12v.2a2.68 2.68 0 0 1 .28-.45 1.5 1.5 0 0 1 .4-.34l.23-.13a.08.08 0 0 1 .1 0 .19.19 0 0 1 0 .12v.53a.59.59 0 0 1 0 .17.25.25 0 0 1-.1.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "217.878px 152.545px"
    },
    id: "el9dwwdbo8b6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 151.9a4.31 4.31 0 0 1 .09-.88 3.64 3.64 0 0 1 .25-.83 3 3 0 0 1 .4-.68 1.65 1.65 0 0 1 .52-.47.91.91 0 0 1 .52-.14.63.63 0 0 1 .39.21 1.2 1.2 0 0 1 .26.49 2.63 2.63 0 0 1 .09.72v.35a.58.58 0 0 1 0 .18.25.25 0 0 1-.1.12l-1.71 1a.81.81 0 0 0 0 .29.39.39 0 0 0 .13.15.26.26 0 0 0 .19 0 .7.7 0 0 0 .23-.08 1.4 1.4 0 0 0 .26-.21.91.91 0 0 0 .17-.23l.09-.14.1-.08.41-.23a.09.09 0 0 1 .1 0 .17.17 0 0 1 0 .13 1.1 1.1 0 0 1-.08.33 2.44 2.44 0 0 1-.22.47 2.74 2.74 0 0 1-.37.49 2 2 0 0 1-.5.41 1 1 0 0 1-.52.15.55.55 0 0 1-.4-.21 1.14 1.14 0 0 1-.25-.53 3.18 3.18 0 0 1-.05-.78Zm1.26-1.91a1.09 1.09 0 0 0-.26.21 1.17 1.17 0 0 0-.17.28 1.88 1.88 0 0 0-.12.3 1.45 1.45 0 0 0 0 .28l1.16-.67v-.23a.32.32 0 0 0-.1-.18.2.2 0 0 0-.17-.08.57.57 0 0 0-.37.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "220.261px 151.16px"
    },
    id: "elpdsg736t08b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.55 150.52a.53.53 0 0 1 0 .17.25.25 0 0 1-.1.12l-.45.19a.08.08 0 0 1-.1 0 .22.22 0 0 1 0-.13v-2a1.28 1.28 0 0 0-.14-.68c-.1-.13-.24-.14-.44 0a1.06 1.06 0 0 0-.43.53 2.11 2.11 0 0 0-.16.85v2a.38.38 0 0 1 0 .17.2.2 0 0 1-.1.12l-.39.22a.06.06 0 0 1-.09 0 .17.17 0 0 1 0-.13v-3.68a.38.38 0 0 1 0-.17.24.24 0 0 1 .09-.12l.39-.23a.09.09 0 0 1 .1 0 .17.17 0 0 1 0 .13v.18a3 3 0 0 1 .32-.52 1.37 1.37 0 0 1 .42-.38.85.85 0 0 1 .53-.16.5.5 0 0 1 .34.2 1.09 1.09 0 0 1 .18.49 3.48 3.48 0 0 1 .06.67Z",
    style: {
      fill: "#455a64",
      transformOrigin: "223.359px 149.55px"
    },
    id: "elhqq65gju19m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77 147.7a2.35 2.35 0 0 0 0 .28 2.18 2.18 0 0 0 0 .27 1.23 1.23 0 0 0 .07.38.45.45 0 0 0 .14.2.41.41 0 0 0 .19 0 .58.58 0 0 0 .21-.07 1.28 1.28 0 0 0 .21-.16.84.84 0 0 0 .15-.18l.11-.19c0-.07.05-.14.08-.22l.07-.18a.24.24 0 0 1 .1-.13l.39-.23a.08.08 0 0 1 .1 0s0 .07 0 .13a1.79 1.79 0 0 1-.08.44 3.32 3.32 0 0 1-.22.59 3 3 0 0 1-.39.59 2 2 0 0 1-.56.47.92.92 0 0 1-.51.15.63.63 0 0 1-.39-.17 1 1 0 0 1-.26-.42 2.35 2.35 0 0 1-.12-.63 2.91 2.91 0 0 1 0-.31v-.33a4.1 4.1 0 0 1 .11-.76 4.22 4.22 0 0 1 .27-.73 2.82 2.82 0 0 1 .39-.62 1.93 1.93 0 0 1 .51-.44 1.1 1.1 0 0 1 .56-.18.62.62 0 0 1 .39.15.74.74 0 0 1 .22.32 1 1 0 0 1 .08.36.35.35 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.23a.08.08 0 0 1-.1 0l-.07-.11-.08-.12a.41.41 0 0 0-.11-.07.24.24 0 0 0-.15 0 1.25 1.25 0 0 0-.21.1 1 1 0 0 0-.21.17 1.17 1.17 0 0 0-.19.27 1.5 1.5 0 0 0-.14.36 2.11 2.11 0 0 0-.07.5Z",
    style: {
      fill: "#455a64",
      transformOrigin: "226.328px 147.545px"
    },
    id: "el49h9b7tt9xc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.05 146.65a4.38 4.38 0 0 1 .09-.88 4.13 4.13 0 0 1 .25-.82 3.29 3.29 0 0 1 .4-.69 1.85 1.85 0 0 1 .52-.46.85.85 0 0 1 .52-.14.62.62 0 0 1 .4.2 1.23 1.23 0 0 1 .25.5 2.6 2.6 0 0 1 .09.71v.36a.35.35 0 0 1 0 .17.25.25 0 0 1-.1.12l-1.71 1a.76.76 0 0 0 .05.29.28.28 0 0 0 .32.19.49.49 0 0 0 .22-.08 1.18 1.18 0 0 0 .27-.2 1.7 1.7 0 0 0 .17-.23.42.42 0 0 1 .09-.14.27.27 0 0 1 .1-.08l.41-.24a.08.08 0 0 1 .1 0s0 .06 0 .12a1.52 1.52 0 0 1-.08.33 2.26 2.26 0 0 1-.23.47 3.31 3.31 0 0 1-.36.5 2.24 2.24 0 0 1-.51.41.93.93 0 0 1-.52.15.65.65 0 0 1-.4-.21 1.38 1.38 0 0 1-.25-.53 3.26 3.26 0 0 1-.09-.82Zm1.26-1.91a.88.88 0 0 0-.25.22 1.27 1.27 0 0 0-.18.27 1.82 1.82 0 0 0-.11.3 1.66 1.66 0 0 0-.05.28l1.16-.67a1.7 1.7 0 0 0 0-.22.48.48 0 0 0-.09-.19.24.24 0 0 0-.17-.07.47.47 0 0 0-.31.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "229.315px 145.934px"
    },
    id: "elkjqohn00lz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58 144.92a.13.13 0 0 0-.16-.16l-.24.05-.38.09a1 1 0 0 1-.37 0 .42.42 0 0 1-.24-.14.71.71 0 0 1-.13-.29 2.54 2.54 0 0 1 0-.41 1.89 1.89 0 0 1 .07-.51 2.66 2.66 0 0 1 .21-.53 2.56 2.56 0 0 1 .33-.48 1.55 1.55 0 0 1 .45-.36 1.2 1.2 0 0 1 .44-.18.62.62 0 0 1 .34 0 .45.45 0 0 1 .21.2.7.7 0 0 1 .09.33.28.28 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.23a.14.14 0 0 1-.12 0h-.08a.21.21 0 0 0-.12 0 .48.48 0 0 0-.23.09 1 1 0 0 0-.28.23.47.47 0 0 0-.12.32.23.23 0 0 0 0 .13.16.16 0 0 0 .11.05h.22l.37-.09c.3-.08.52-.05.64.1a1 1 0 0 1 .19.68 1.92 1.92 0 0 1-.08.51 2.38 2.38 0 0 1-.22.53 2.8 2.8 0 0 1-.36.49 2 2 0 0 1-.48.38 1.1 1.1 0 0 1-.48.18.57.57 0 0 1-.35-.05.49.49 0 0 1-.22-.23.77.77 0 0 1-.1-.37.27.27 0 0 1 0-.17.25.25 0 0 1 .1-.12l.39-.23a.11.11 0 0 1 .12 0l.08.07a.22.22 0 0 0 .14.05.53.53 0 0 0 .26-.09l.16-.11.15-.14a.61.61 0 0 0 .12-.16.38.38 0 0 0 .06-.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "232.14px 144.317px"
    },
    id: "el5jy4eiisd9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.05 181.74 1.16.53.11.08a.24.24 0 0 1 .06.17v.68a.31.31 0 0 1 0 .13.15.15 0 0 1-.08.09h-.06l-1.79-.82a.24.24 0 0 1-.11-.08.25.25 0 0 1 0-.17V182a.48.48 0 0 1 0-.22 1 1 0 0 1 .11-.2l1.79-2.9a.06.06 0 0 1 .08 0 .13.13 0 0 1 0 .1v.67a.53.53 0 0 1-.06.24 1.2 1.2 0 0 1-.11.2Z",
    style: {
      fill: "#455a64",
      transformOrigin: "167.356px 181.042px"
    },
    id: "elx7q8wfm8hwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22 183.25a.08.08 0 0 1-.1 0 .17.17 0 0 1 0-.13V178a.35.35 0 0 1 0-.17.25.25 0 0 1 .1-.12l1.51-.87a1 1 0 0 1 .55-.17.51.51 0 0 1 .35.19.8.8 0 0 1 .19.39 2 2 0 0 1 .06.48 2.12 2.12 0 0 1 0 .44 1.81 1.81 0 0 1-.1.37 2.85 2.85 0 0 1-.12.29l-.09.17a.7.7 0 0 1 .29.3 1.41 1.41 0 0 1 .14.7 2.86 2.86 0 0 1-.08.63 2.54 2.54 0 0 1-.21.66 2.59 2.59 0 0 1-.34.58 1.58 1.58 0 0 1-.48.42Zm2-5.07c0-.2 0-.32-.12-.38s-.21 0-.39.07l-.91.53v1.21l.91-.52a1 1 0 0 0 .39-.38 1.12 1.12 0 0 0 .09-.53Zm-1.45 3.82.95-.55a1 1 0 0 0 .41-.42 1.21 1.21 0 0 0 .13-.56.5.5 0 0 0-.13-.41c-.09-.08-.23-.06-.41 0l-.95.55Z",
    style: {
      fill: "#455a64",
      transformOrigin: "170.555px 179.969px"
    },
    id: "el0mlx0cq7vzel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55 178.24a1.87 1.87 0 0 1 .1-.41 1.67 1.67 0 0 1 .21-.48 2.43 2.43 0 0 1 .33-.46 1.7 1.7 0 0 1 .46-.38 1.09 1.09 0 0 1 .47-.16.5.5 0 0 1 .36.1.75.75 0 0 1 .23.38 2.13 2.13 0 0 1 .09.67v2.32a.47.47 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.23a.08.08 0 0 1-.1 0 .15.15 0 0 1 0-.12V180a2.67 2.67 0 0 1-.31.57 1.75 1.75 0 0 1-.52.45.84.84 0 0 1-.39.14.36.36 0 0 1-.29-.09.57.57 0 0 1-.18-.28 1.27 1.27 0 0 1-.07-.46 2.15 2.15 0 0 1 .25-1 2.83 2.83 0 0 1 .67-.8l.84-.71c0-.21 0-.34-.14-.37a.37.37 0 0 0-.34.06.58.58 0 0 0-.2.17 1.28 1.28 0 0 0-.14.23.56.56 0 0 1-.09.14.27.27 0 0 1-.08.07l-.48.28a.06.06 0 0 1-.08 0 .1.1 0 0 1-.11-.16Zm.86 1.73a1.26 1.26 0 0 0 .31-.26 1.94 1.94 0 0 0 .23-.33 1.74 1.74 0 0 0 .13-.36 1.55 1.55 0 0 0 0-.35v-.08l-.7.59a1.28 1.28 0 0 0-.3.34.67.67 0 0 0-.09.34c0 .11 0 .17.11.18a.41.41 0 0 0 .31-.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "173.629px 178.755px"
    },
    id: "elf5kh6cb1k5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 177a2.44 2.44 0 0 0 0 .28 2.1 2.1 0 0 0 0 .27 1.17 1.17 0 0 0 .07.38.45.45 0 0 0 .14.2.32.32 0 0 0 .19.05.65.65 0 0 0 .21-.07 1.16 1.16 0 0 0 .21-.16.8.8 0 0 0 .15-.17 2 2 0 0 0 .11-.2c0-.07.05-.14.08-.22l.07-.18a.28.28 0 0 1 .1-.13l.39-.22a.09.09 0 0 1 .1 0 .17.17 0 0 1 0 .13 2.69 2.69 0 0 1-.08.45 3.24 3.24 0 0 1-.22.58 3 3 0 0 1-.39.59 2.16 2.16 0 0 1-.56.48 1 1 0 0 1-.51.14.58.58 0 0 1-.39-.17 1 1 0 0 1-.26-.42 2 2 0 0 1-.12-.62 3 3 0 0 1 0-.31v-.33a4.1 4.1 0 0 1 .11-.76 4.81 4.81 0 0 1 .26-.73 2.93 2.93 0 0 1 .4-.63 1.93 1.93 0 0 1 .51-.44 1.07 1.07 0 0 1 .56-.17.68.68 0 0 1 .39.14.83.83 0 0 1 .22.33 1.31 1.31 0 0 1 .08.36.38.38 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.22a.08.08 0 0 1-.1 0l-.07-.1a.62.62 0 0 0-.08-.12.28.28 0 0 0-.11-.08.38.38 0 0 0-.15 0 .6.6 0 0 0-.21.09.83.83 0 0 0-.21.17 1.85 1.85 0 0 0-.19.27 1.5 1.5 0 0 0-.14.36 2.11 2.11 0 0 0-.07.45Z",
    style: {
      fill: "#455a64",
      transformOrigin: "176.56px 176.91px"
    },
    id: "el5g7anhhqkv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.1 176v1.36a.38.38 0 0 1 0 .17.25.25 0 0 1-.1.12l-.39.22a.07.07 0 0 1-.09 0 .17.17 0 0 1 0-.13v-5.18a.35.35 0 0 1 0-.17.24.24 0 0 1 .09-.12l.39-.27a.08.08 0 0 1 .1 0 .17.17 0 0 1 0 .13v2.48l.86-1.56.04-.05a.34.34 0 0 1 .12-.12l.52-.3h.09a.16.16 0 0 1 0 .11v.08a.48.48 0 0 1-.05.11l-1.2 2.17 1.31 1.18v.06a.13.13 0 0 1 0 .06.41.41 0 0 1 0 .16.3.3 0 0 1-.09.1l-.5.29a.17.17 0 0 1-.13 0 .2.2 0 0 1-.08 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "179.652px 174.934px"
    },
    id: "el4czxyb9drq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 124.3a.28.28 0 0 1-.23-.13.26.26 0 0 1 .1-.36l6.53-3.77a.26.26 0 1 1 .26.45l-6.53 3.77a.22.22 0 0 1-.13.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "265.326px 122.15px"
    },
    id: "el6qwb9mvndz2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 127.18a.26.26 0 0 1-.23-.13.25.25 0 0 1 .1-.35l6.53-3.78a.26.26 0 0 1 .26.46l-6.53 3.77a.31.31 0 0 1-.13.03Z",
    style: {
      fill: "#455a64",
      transformOrigin: "265.324px 125.033px"
    },
    id: "el4yi5jg2r3n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 130.07a.26.26 0 0 1-.23-.13.27.27 0 0 1 .1-.36l6.53-3.77a.26.26 0 0 1 .26.46l-6.53 3.73a.31.31 0 0 1-.13.07Z",
    style: {
      fill: "#455a64",
      transformOrigin: "265.326px 127.923px"
    },
    id: "elofnm56z45l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 123.06c.46-.26.83 0 .83.48A1.78 1.78 0 0 1 262 125c-.46.26-.83.05-.83-.47a1.85 1.85 0 0 1 .83-1.47Z",
    style: {
      fill: "#455a64",
      transformOrigin: "262px 124.034px"
    },
    id: "el1cpbhvkg2rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08 123.06c.45-.26.82 0 .82.48a1.78 1.78 0 0 1-.83 1.42c-.46.26-.83.05-.83-.47a1.86 1.86 0 0 1 .84-1.43Z",
    style: {
      fill: "#455a64",
      transformOrigin: "267.07px 124.014px"
    },
    id: "elf6f7psu0ui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87 127.23c.46-.26.83 0 .83.48a1.81 1.81 0 0 1-.83 1.43c-.46.26-.83 0-.83-.48a1.9 1.9 0 0 1 .83-1.43Z",
    style: {
      fill: "#455a64",
      transformOrigin: "264.87px 128.185px"
    },
    id: "elhpexw6gzr0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.46 159.45a.29.29 0 0 1 0-.17v-.83l-1.3.75c-.07 0-.11 0-.11-.11V158.63l.05-.16 1.38-3.77a1.13 1.13 0 0 1 .07-.15.24.24 0 0 1 .09-.08l.18-.11h.12a.36.36 0 0 1 0 .18v2.9l.29-.16h.11a.26.26 0 0 1 0 .18v.2a.41.41 0 0 1 0 .21.25.25 0 0 1-.11.12l-.29.17v.84a.58.58 0 0 1 0 .21.49.49 0 0 1-.12.13l-.22.12c-.08.02-.11.02-.14-.01Zm0-1.75v-2.07l-.94 2.61Z",
    style: {
      fill: "#455a64",
      transformOrigin: "180.203px 156.917px"
    },
    id: "elolpfemxsxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 158.06a2.7 2.7 0 0 1-.39-1.7 5.33 5.33 0 0 1 .39-2.13 2.6 2.6 0 0 1 1.07-1.3 1.58 1.58 0 0 1 .52-.19.55.55 0 0 1 .41.06s0 0 0 .07a.34.34 0 0 1 0 .09l-.12.44a.31.31 0 0 1 0 .09h-.06a.75.75 0 0 0-.66.1 1.76 1.76 0 0 0-.73.9 4 4 0 0 0-.27 1.57 2.17 2.17 0 0 0 .26 1.28c.17.22.41.23.71.06a2.13 2.13 0 0 0 .32-.23 1.58 1.58 0 0 0 .25-.28v-1.35l-.54.31h-.11c-.02 0 0-.09 0-.19v-.19a.41.41 0 0 1 0-.21.25.25 0 0 1 .11-.12l.87-.5h.12c.02 0 0 .1 0 .21v1.92a.76.76 0 0 1 0 .17.29.29 0 0 1 0 .13 2.73 2.73 0 0 1-1 1c-.53.31-.89.29-1.15-.01Z",
    style: {
      fill: "#455a64",
      transformOrigin: "182.877px 155.509px"
    },
    id: "el9jh1kt25tmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 151.43a2 2 0 0 1-.75 1.6c-.42.24-.76-.08-.76-.73a2 2 0 0 1 .76-1.59c.36-.24.75.08.75.72Z",
    style: {
      fill: "#455a64",
      transformOrigin: "192.245px 151.87px"
    },
    id: "elurq8uc373r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2 148.81a4.56 4.56 0 0 0-1.76 2.63c-.06.24 0 .46.08.53.14.09.35-.1.43-.39a3.21 3.21 0 0 1 1.24-1.86.8.8 0 0 1 1.23.43c.09.2.3.15.44-.11a.78.78 0 0 0 .08-.62 1.13 1.13 0 0 0-1.74-.61Z",
    style: {
      fill: "#455a64",
      transformOrigin: "192.193px 150.297px"
    },
    id: "elzic5gmaync8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2 147a7.07 7.07 0 0 0-2.69 3.83c-.09.25-.06.5.06.58.14.09.34-.08.43-.37a5.75 5.75 0 0 1 2.2-3.13 1.46 1.46 0 0 1 2.2.6c.09.17.29.11.43-.13a.77.77 0 0 0 .06-.65 1.79 1.79 0 0 0-2.69-.73Z",
    style: {
      fill: "#455a64",
      transformOrigin: "192.197px 149.047px"
    },
    id: "el3kuwlsqoufk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.89 138.34a.29.29 0 0 1 0-.14.48.48 0 0 1 0-.17l1.09-1.94.08-.13a.3.3 0 0 1 .09-.1l.39-.22a.08.08 0 0 1 .1 0 .23.23 0 0 1 0 .13v5a.45.45 0 0 1 0 .16.25.25 0 0 1-.1.12l-.4.23a.09.09 0 0 1-.1 0 .22.22 0 0 1 0-.13v-3.79l-.71 1.26a.22.22 0 0 1-.09.1.1.1 0 0 1-.1 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "212.765px 138.459px"
    },
    id: "el29mowvw39pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.41 136.88a.2.2 0 0 1 0-.14.37.37 0 0 1 .05-.17l1.08-1.94.08-.13a.3.3 0 0 1 .09-.1l.39-.22a.08.08 0 0 1 .1 0 .17.17 0 0 1 0 .12v5a.59.59 0 0 1 0 .17.27.27 0 0 1-.1.11l-.4.24a.09.09 0 0 1-.1 0 .21.21 0 0 1 0-.12v-3.8l-.7 1.27a.2.2 0 0 1-.1.09.06.06 0 0 1-.09 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "215.304px 136.999px"
    },
    id: "elv4mrfbujpei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.72 134.75a.08.08 0 0 1 .1 0 .19.19 0 0 1 0 .12v.75a.47.47 0 0 1 0 .17.25.25 0 0 1-.1.12l-.46.27a.08.08 0 0 1-.1 0 .19.19 0 0 1 0-.12v-.75a.47.47 0 0 1 0-.17.25.25 0 0 1 .1-.12Zm0 2.69a.08.08 0 0 1 .1 0 .17.17 0 0 1 0 .12v.75a.53.53 0 0 1 0 .17.31.31 0 0 1-.1.12l-.46.26a.09.09 0 0 1-.1 0 .23.23 0 0 1 0-.13V138a.55.55 0 0 1 0-.17.27.27 0 0 1 .1-.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "217.491px 136.804px"
    },
    id: "elsoza4xw5wl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.39 137.07a.08.08 0 0 1-.1 0 .19.19 0 0 1 0-.12V136l-1.54.89a.09.09 0 0 1-.1 0 .17.17 0 0 1 0-.13v-.54a.76.76 0 0 1 0-.21c0-.07.05-.14.08-.22l1.53-3.81a.57.57 0 0 1 .2-.31l.38-.22a.08.08 0 0 1 .1 0 .17.17 0 0 1 0 .12v3.07l.43-.25a.08.08 0 0 1 .1 0 .16.16 0 0 1 0 .12v.55a.38.38 0 0 1 0 .17.27.27 0 0 1-.1.11l-.43.25v.93a.51.51 0 0 1 0 .17.31.31 0 0 1-.1.12Zm-.14-2v-1.64l-.85 2.13Z",
    style: {
      fill: "#455a64",
      transformOrigin: "220.059px 134.26px"
    },
    id: "elr4ugg3ri37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.39 130.74a.32.32 0 0 1 0-.16.25.25 0 0 1 .1-.12l1.87-1.08h.09a.17.17 0 0 1 0 .13v.54a.35.35 0 0 1 0 .17.19.19 0 0 1-.09.12l-1.4.81-.06 1a1.23 1.23 0 0 1 .27-.25l.22-.14a1.32 1.32 0 0 1 .52-.19.63.63 0 0 1 .41.1.79.79 0 0 1 .27.4 2 2 0 0 1 .1.71 3.57 3.57 0 0 1-.1.89 3.08 3.08 0 0 1-.28.74 2.45 2.45 0 0 1-.41.57 2.36 2.36 0 0 1-.51.4 1.67 1.67 0 0 1-.59.22.6.6 0 0 1-.41-.1.74.74 0 0 1-.25-.34 2 2 0 0 1-.09-.52.33.33 0 0 1 0-.17.31.31 0 0 1 .1-.12l.4-.23a.08.08 0 0 1 .09 0s0 .05.05.1a.45.45 0 0 0 .1.23.24.24 0 0 0 .15.09.26.26 0 0 0 .19 0 1.38 1.38 0 0 0 .22-.1 1.24 1.24 0 0 0 .46-.5 1.73 1.73 0 0 0 .17-.76.56.56 0 0 0-.17-.47.39.39 0 0 0-.46 0 .92.92 0 0 0-.24.17 1 1 0 0 0-.14.16l-.1.14a.4.4 0 0 1-.12.1l-.45.26a.09.09 0 0 1-.1 0 .17.17 0 0 1 0-.13Z",
    style: {
      fill: "#455a64",
      transformOrigin: "223.365px 132.492px"
    },
    id: "elu0dv76sv0ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "166.81px 167.15px"
    },
    id: "elj3aiy64e9",
    className: "animable",
    d: "M166.12 168.35v-1.6l1.38-.8v1.6l-1.38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "168.885px 165.15px"
    },
    id: "elyg55a5octzp",
    className: "animable",
    d: "M168.19 167.15v-3.2l1.39-.8v3.2l-1.39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "170.965px 163.15px"
    },
    id: "el1sl1i6f4xw5j",
    className: "animable",
    d: "M170.27 165.95v-4.8l1.39-.8v4.8l-1.39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "173.045px 161.15px"
    },
    id: "elxjv8sj201h8",
    className: "animable",
    d: "M172.35 164.75v-6.4l1.39-.8v6.4l-1.39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69 103.36c-.15-.21-.33-.27-.52-.16l-5.17 3a2 2 0 0 0-.6 1.57v2.91a1.73 1.73 0 0 0 .22.93.6.6 0 0 0 .21.19.31.31 0 0 0 .31 0l5.18-3a2 2 0 0 0 .59-1.57v-2.91a1.78 1.78 0 0 0-.22-.96Zm-5.92 7.85a.79.79 0 0 1-.09-.43v-2.91a1.56 1.56 0 0 1 .46-1.2l5.18-3a.16.16 0 0 1 .16 0 .19.19 0 0 1 .07.06.83.83 0 0 1 .08.42v2.91a1.54 1.54 0 0 1-.46 1.2l-5.17 3c-.1.04-.18.03-.23-.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "266.655px 107.494px"
    },
    id: "ellbqqx9cosa9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12 106.61v3.44l-.81.47a.11.11 0 0 1-.16-.09v-2.56a1.19 1.19 0 0 1 .34-.89Z",
    style: {
      fill: "#455a64",
      transformOrigin: "264.634px 108.571px"
    },
    id: "el2ddia0ghzxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "265.985px 107.84px"
    },
    id: "elb047675mo6j",
    className: "animable",
    d: "m265.5 106.4.97-.56v3.44l-.97.56v-3.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "267.335px 107.065px"
    },
    id: "elxfxskkjdff",
    className: "animable",
    d: "m266.85 105.63.97-.57v3.46l-.97.55v-3.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.17 104.52V107a1.28 1.28 0 0 1-.65 1.11l-.32.19v-3.44l.77-.45a.13.13 0 0 1 .2.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "268.685px 106.345px"
    },
    id: "ely29giz0upp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11 104.2c.14-.09.26.33.26.92v.54a2.08 2.08 0 0 1-.27 1.26l-.26.18v-2.75Z",
    style: {
      fill: "#455a64",
      transformOrigin: "270.111px 105.644px"
    },
    id: "el9zab1qyc7t6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "258.055px 111.795px"
    },
    id: "elmx7cfxsnap",
    className: "animable",
    d: "m255.54 112.99 5.03-4.47-1.55 6.55-.73-2.72-2.75.64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-127",
    className: "animable",
    style: {
      transformOrigin: "339.134px 273.048px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-127",
    className: "animable",
    style: {
      transformOrigin: "339.134px 273.048px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.62 414.64c-.35.12-.41 2.15-.09 2.82s2.57 3.19 7.1 4.08 10.74 0 13.41-.16 11.09.86 13.76 1.22c4.2.57 7.43-.35 9-1.87a2.81 2.81 0 0 0 .63-2.21c-.08-1.77-.24-2.13-.45-2.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "344.39px 418.705px"
    },
    id: "elyw7uvfpvzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.28 411.13c.09.35.16.7.23 1.05a17.88 17.88 0 0 1 .39 5.45 4.94 4.94 0 0 1-3.23 2.44c-3.15 1-5.57.84-9.07.18a63.84 63.84 0 0 0-10.6-.65c-2.76.18-6.56.71-9.31.46a22.11 22.11 0 0 1-6.85-1.4c-1.85-.79-3.72-1.8-4.17-3.69a6.23 6.23 0 0 1 3.46-6.23 14 14 0 0 1 6.92-1.49c2.61 0 4.58.34 6.89.16a32.28 32.28 0 0 0 6-.82c1.74-.55 3.17-.66 3.84-2.37.33-.84.5-1.56 1.24-1.64 0 0 10.92-.27 12-.17 1.28.1 1.51 4.51 1.67 5.37.12.67.15 1.4.33 2.05.05.43.16.86.26 1.3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "344.299px 411.585px"
    },
    id: "elpnwsw55ow1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "344.299px 411.585px"
    },
    className: "animable",
    id: "el3rl3uts4b28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.28 411.13c.09.35.16.7.23 1.05a17.88 17.88 0 0 1 .39 5.45 4.94 4.94 0 0 1-3.23 2.44c-3.15 1-5.57.84-9.07.18a63.84 63.84 0 0 0-10.6-.65c-2.76.18-6.56.71-9.31.46a22.11 22.11 0 0 1-6.85-1.4c-1.85-.79-3.72-1.8-4.17-3.69a6.23 6.23 0 0 1 3.46-6.23 14 14 0 0 1 6.92-1.49c2.61 0 4.58.34 6.89.16a32.28 32.28 0 0 0 6-.82c1.74-.55 3.17-.66 3.84-2.37.33-.84.5-1.56 1.24-1.64 0 0 10.92-.27 12-.17 1.28.1 1.51 4.51 1.67 5.37.12.67.15 1.4.33 2.05.05.43.16.86.26 1.3Z",
    id: "el0jxjvemrvzp6",
    className: "animable",
    style: {
      transformOrigin: "344.299px 411.585px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.89 407a7.89 7.89 0 0 0-2.84 4.91c.06 1.33-2.29 1.45-2.35.11a11.38 11.38 0 0 1 2.07-4.69 5.76 5.76 0 0 1 3.12-.33Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "341.295px 409.942px"
    },
    id: "elkwcug9von9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.66 407.46a8.35 8.35 0 0 0-2.52 4.52c0 1-2.08.9-2.05-.09 0 0 .28-3.15 2.53-4.49.65-.4 1.83-.33 2.04.06Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "336.375px 409.907px"
    },
    id: "elz6p61zub9sh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 379.39c-.35 3.74-.44 4.75.48 7.2 1.32 3.52 3.66 5.15 5.24 6.51a26.89 26.89 0 0 1 4.64 5.4 23.16 23.16 0 0 0 4.84 5.81c1.5 1.25 5.66 1.28 7.65.4s2.64-1.65 2.45-4.85-9.91-4.09-9.91-4.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "382.542px 392.353px"
    },
    id: "elte80s85obs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.86 390.34c.83.3 1.07 1.87 1.26 5 .14 2.37 1.21 5.83-2 7.39-2.61 1.26-6.84.54-8.66-1.66-2.28-2.75-3.83-5.17-7.07-8.51-2.81-2.9-5.7-3.84-7-9.72-.86-3.78-.27-5.36 2.26-6.5 3.48-1.57 9.09 3.21 11.86 3.93 2.31.61 8.49 9.78 9.35 10.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "382.711px 389.687px"
    },
    id: "el54mha6f0j2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.86 390.34c.83.3 1.07 1.87 1.26 5 .14 2.37 1.21 5.83-2 7.39-2.61 1.26-6.84.54-8.66-1.66-2.28-2.75-3.83-5.17-7.07-8.51-2.81-2.9-5.7-3.84-7-9.72-.86-3.78-.27-5.36 2.26-6.5 3.48-1.57 9.09 3.21 11.86 3.93 2.31.61 8.49 9.78 9.35 10.07Z",
    style: {
      opacity: 0.4,
      transformOrigin: "382.711px 389.687px"
    },
    className: "animable",
    id: "elrhxh927ubrc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.44 380.27c-.15 0-.31-.1-.47-.16a9.07 9.07 0 0 0-7.5 5.14c-.45 1 1 1.82 1.85 1 1.89-3.94 5.9-4.89 7.5-5.11a3.91 3.91 0 0 0-1.38-.87Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "381.103px 383.348px"
    },
    id: "elbzminpvxb4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.75 382a9 9 0 0 0-7 5.08c-.44 1 1 1.82 1.86 1a9.26 9.26 0 0 1 6.24-4.86c-.36-.43-.74-.84-1.1-1.22Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "383.759px 385.208px"
    },
    id: "elhnt15rnnoou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.24 384-.39 7.72c-.31 1.75-10.05 2.52-10.38-.43-.17-.36-.56-6.62-.56-6.62Z",
    style: {
      fill: "#b16668",
      transformOrigin: "388.575px 388.635px"
    },
    id: "eleqn5wmyo3wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05 387.73c.83-11.9 6.18-39.59 5.19-57.4L377 332.67s1.51 12 2.71 25.17 3.77 33.46 3.77 33.46Z",
    style: {
      fill: "#b16668",
      transformOrigin: "388.181px 360.815px"
    },
    id: "eli4teraeagmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.69 398.42s-.12 2.86-.16 4.49-2 4-7 3.64c-3.49-.25-5.91-1.27-5.67-4.15l.15-4.16Z",
    style: {
      fill: "#b16668",
      transformOrigin: "357.267px 402.413px"
    },
    id: "elhcvbi6ufqou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54 402.41c1.76-15.51 4.39-39.53 4.75-48 .29-6.8-.73-15.84-2.44-20.62l-21.35 2 6.37 65.43Z",
    style: {
      fill: "#b16668",
      transformOrigin: "356.42px 368.1px"
    },
    id: "el9qq0lz4010e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.87 353.08a55.08 55.08 0 0 0-2.44-19.76s4.93-41.13 5.69-47.75c0 0 1 11.8 1.89 20.78s1.54 16.66 3.81 35.23c12.5 4.79 21.68-1 21.68-1 .17-2.3.26-4.23.26-5.6 0-12.64-2.46-18.76-2.46-18.76s.95-15.4 1.95-35.73c1.44-29.36 0-33.33-6-46.36 0 0-47.65-5.53-48.74 14.94-1.36 25.5-1.59 77.43-.73 86.41.66 7 1.1 12.25 2.35 19.35-.01.04 12.42 4.17 22.74-1.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "371.52px 294.859px"
    },
    id: "elpt5yhtokzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "371.475px 294.866px"
    },
    className: "animable",
    id: "elnus9kye6qhq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.87 353.08a55.08 55.08 0 0 0-2.44-19.76s4.93-41.13 5.69-47.75c0 0 1 11.8 1.89 20.78s1.54 16.66 3.81 35.23c12.5 4.79 21.68-1 21.68-1 .17-2.3.26-4.23.26-5.6 0-12.64-2.46-18.76-2.46-18.76s.95-15.4 1.95-35.73c1.44-29.36 0-33.33-6-46.36 0 0-47.65-5.53-48.74 14.94-1.36 25.5-1.59 77.43-.73 86.41.66 7 1.1 12.25 2.35 19.35-.01.04 12.42 4.17 22.74-1.75Z",
    style: {
      fill: "#fff",
      transformOrigin: "371.52px 294.859px"
    },
    id: "ellkza1f27hy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92 356.76a34.84 34.84 0 0 1-10-1.42l-.28-.09-.05-.3c-1.14-6.47-1.6-11.34-2.18-17.52l-.18-1.86c-.88-9.22-.6-61.6.73-86.48a12.17 12.17 0 0 1 4.57-8.92c12-10.16 43.4-6.65 44.73-6.49h.28l.12.25c6.09 13.18 7.48 17.4 6.05 46.6-.95 19.21-1.85 34.19-1.94 35.62.34.9 2.48 7 2.45 18.84 0 1.31-.09 3.21-.26 5.63v.26l-.22.13c-.09.06-9.53 5.84-22.12 1l-.28-.1v-.3c-2.08-17-2.81-24.8-3.59-33l-.22-2.22c-.5-5.32-1.08-11.68-1.46-15.95-1.46 12.38-4.86 40.78-5.11 42.82a56.39 56.39 0 0 1 2.43 19.84v.26l-.23.14a26.32 26.32 0 0 1-13.24 3.26Zm-9.36-2.28c1.87.55 12.72 3.4 21.83-1.71a55 55 0 0 0-2.39-19.28V333.26c.05-.41 4.93-41.21 5.68-47.75l.56-4.91.44 4.92c0 .12 1 11.91 1.89 20.78l.21 2.22c.78 8.17 1.51 15.89 3.56 32.7a25.42 25.42 0 0 0 20.74-.9c.16-2.28.24-4.06.24-5.3 0-12.37-2.4-18.52-2.42-18.58V316.23c0-.16 1-15.63 1.95-35.72 1.41-28.77.07-33.07-5.84-45.87-3.19-.33-32.59-3.09-43.7 6.29a11.24 11.24 0 0 0-4.21 8.21c-1.33 24.85-1.61 77.14-.74 86.34l.18 1.86c.46 6.05.93 10.86 2.02 17.14Z",
    style: {
      fill: "#fff",
      transformOrigin: "371.475px 294.866px"
    },
    id: "elg9hl2sxaeik",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.29 337.19c-1 0-1.25.87-.84 4 .33 2.54.88 7.13 1.34 7.86.72 1.14 5.77 2.51 11.22 2.21 7.19-.38 10.14-1.93 10.59-2.9s1-6.71 1.11-8.69c.15-2.14 0-3.12-.94-3.27l-.11 1.72s-2.36 2.85-11.23 3-10.93-2.22-10.93-2.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "388.511px 343.851px"
    },
    id: "elg89cy6jyxob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "388.488px 343.89px"
    },
    className: "animable",
    id: "elmpq30madlz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.29 337.19c-1 0-1.25.87-.84 4 .33 2.54.88 7.13 1.34 7.86.72 1.14 5.77 2.51 11.22 2.21 7.19-.38 10.14-1.93 10.59-2.9s1-6.71 1.11-8.69c.15-2.14 0-3.12-.94-3.27l-.11 1.72s-2.36 2.85-11.23 3-10.93-2.22-10.93-2.22Z",
    style: {
      fill: "#fff",
      transformOrigin: "388.511px 343.851px"
    },
    id: "elw0t6j8re4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5 351.84c-4.93 0-9.34-1.24-10.13-2.48-.45-.71-.87-3.81-1.34-7.47l-.08-.6c-.31-2.45-.24-3.58.28-4.17a1.36 1.36 0 0 1 1-.43h.45l.24 2c.49.4 3 2.07 10.45 2s10.21-2.2 10.75-2.69l.13-2.08.54.09c1.49.24 1.5 1.93 1.37 3.79 0 .08-.52 7.47-1.15 8.86-.57 1.24-3.79 2.81-11 3.2-.49-.03-1.01-.02-1.51-.02ZM376.88 338a10.08 10.08 0 0 0 .07 3.2l.07.59c.27 2.11.83 6.48 1.19 7.06.55.87 5.37 2.28 10.78 2 7.53-.4 9.89-2 10.16-2.61.41-.89.89-6 1.06-8.51a9.13 9.13 0 0 0 0-2.05v.72l-.11.12c-.1.13-2.6 3-11.6 3.16s-11.24-2.3-11.32-2.4l-.1-.11Z",
    style: {
      fill: "#fff",
      transformOrigin: "388.488px 343.89px"
    },
    id: "elrprj602588",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.29 337.19c-1 0-1.25.87-.84 4 .33 2.54.88 7.13 1.34 7.86.72 1.14 5.77 2.51 11.22 2.21 7.19-.38 10.14-1.93 10.59-2.9s1-6.71 1.11-8.69c.15-2.14 0-3.12-.94-3.27l-.11 1.72s-2.36 2.85-11.23 3-10.93-2.22-10.93-2.22Z",
    style: {
      opacity: 0.1,
      transformOrigin: "388.511px 343.851px"
    },
    className: "animable",
    id: "elckfi8b6h7rm"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "349.171px 302.46px"
    },
    className: "animable",
    id: "elhrogtbm46b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.79 354.11c0-.07-.64-7.1-1.73-26.1-1.08-18.67-.41-61.06 1.73-77.2l1 .13c-2.13 16.1-2.8 58.38-1.72 77 1.09 19 1.72 26 1.72 26.07Z",
    id: "elsdtbegilqla",
    className: "animable",
    style: {
      transformOrigin: "349.171px 302.46px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345 347.66c-1.47.56-1.12 1.37-.53 5.08s.4 5 1.09 6 4.75 2.34 12.44 2.07 11.36-3 11.74-3.87.35-2.76.18-5.52.2-5.36-1.12-5.25l.11 2s-3.45 2.95-10.69 3.26c-9.3.38-12.92-1.54-12.92-1.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "357.001px 353.506px"
    },
    id: "eld65e9emlu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "357.003px 353.506px"
    },
    className: "animable",
    id: "el6tmg5wcxowf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345 347.66c-1.47.56-1.12 1.37-.53 5.08s.4 5 1.09 6 4.75 2.34 12.44 2.07 11.36-3 11.74-3.87.35-2.76.18-5.52.2-5.36-1.12-5.25l.11 2s-3.45 2.95-10.69 3.26c-9.3.38-12.92-1.54-12.92-1.54Z",
    style: {
      fill: "#fff",
      transformOrigin: "357.001px 353.506px"
    },
    id: "eliofpi2qgvgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 361.35c-6.36 0-10.06-1.15-10.85-2.32a6.36 6.36 0 0 1-.77-3.09c-.09-.81-.2-1.81-.41-3.12-.07-.46-.14-.87-.2-1.25-.45-2.72-.62-3.74 1.05-4.38l.59-.23.35 2.6c.91.38 4.67 1.7 12.44 1.38 6.07-.26 9.4-2.41 10.19-3l-.11-2.22.48-.05a1.16 1.16 0 0 1 .91.29c.65.58.67 1.84.69 3.57 0 .59 0 1.22.06 1.86.18 2.94.2 4.82-.22 5.76S366 361 358 361.31c-.65.03-1.33.04-2 .04Zm-11.4-12.87c-.25.35-.16 1 .16 2.93.06.38.13.79.2 1.26.21 1.33.32 2.34.41 3.16a5.78 5.78 0 0 0 .61 2.64c.49.73 4.07 2.13 12 1.85 7.39-.27 11-2.89 11.31-3.57s.26-3.16.13-5.29c0-.65-.05-1.3-.06-1.9v-1.09l-.11.09c-.14.13-3.66 3.07-11 3.37-9.32.4-13-1.5-13.17-1.59l-.23-.12Z",
    style: {
      fill: "#fff",
      transformOrigin: "357.003px 353.506px"
    },
    id: "elobqnwwwsc8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345 347.66c-1.47.56-1.12 1.37-.53 5.08s.4 5 1.09 6 4.75 2.34 12.44 2.07 11.36-3 11.74-3.87.35-2.76.18-5.52.2-5.36-1.12-5.25l.11 2s-3.45 2.95-10.69 3.26c-9.3.38-12.92-1.54-12.92-1.54Z",
    style: {
      opacity: 0.1,
      transformOrigin: "357.001px 353.506px"
    },
    className: "animable",
    id: "elbrnb5jnvjj5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.87 270.52c-3.22 0-8.54-2.8-9.56-4.3-.92-1.34-.82-4.39-.64-9.93.06-1.76.13-3.77.17-6v-.48l18.57-.66.07.45c.2 1.37 1.93 13.51.24 15.93-.99 1.41-5.62 4.99-8.85 4.99Zm-9-19.78c0 2.08-.1 3.94-.16 5.58-.17 5.16-.27 8.27.46 9.34s5.83 3.86 8.74 3.86 7.09-3.23 8-4.6c1.08-1.55.4-9.51-.35-14.77Z",
    style: {
      opacity: 0.1,
      transformOrigin: "368.502px 259.835px"
    },
    className: "animable",
    id: "elkoreq1l59so"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.11 265.77c-1.23-.24-6-2.85-6.3-3.58a16.56 16.56 0 0 1-.13-1.91 78.91 78.91 0 0 0-1.3-12.13l-1 .19a77.58 77.58 0 0 1 1.28 12 15.75 15.75 0 0 0 .16 2.12c.34 1.36 6 4.1 7.08 4.31h.22a5.11 5.11 0 0 0 2.61-1.36v-1.34c-1.08 1-2.2 1.78-2.62 1.7Z",
    style: {
      opacity: 0.1,
      transformOrigin: "394.055px 257.46px"
    },
    className: "animable",
    id: "elp6o674b62al"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.12 285.57.62-8.41a68.9 68.9 0 0 0 15-7.53 20.19 20.19 0 0 1-12.08 9.17l-1.52 8.2-.14 19.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "379.93px 287.99px"
    },
    id: "el3s77qfa35cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.12 285.57.62-8.41a68.9 68.9 0 0 0 15-7.53 20.19 20.19 0 0 1-12.08 9.17l-1.52 8.2-.14 19.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "379.93px 287.99px"
    },
    className: "animable",
    id: "eldrfhc9bkp4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.12 285.57.62-8.41a68.9 68.9 0 0 0 15-7.53 20.19 20.19 0 0 1-12.08 9.17l-1.52 8.2-.14 19.35Z",
    style: {
      opacity: 0.1,
      transformOrigin: "379.93px 287.99px"
    },
    className: "animable",
    id: "el80fw2qfbupc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6 175.7c8.64-.75 13.35 2.4 17 11.25s10.54 29.33 12 35.27c.62 2.57.27 3.87-.57 5.25-4.24 6.95-18.32 22.87-17.72 22.58.22-.11-6.55-11.44-6.55-11.44l9.76-15-6.11-16.3Z",
    style: {
      fill: "#b16668",
      transformOrigin: "399.258px 212.824px"
    },
    id: "elgblsjyz7aj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.46 175.73a20.36 20.36 0 0 1 7.12-.13c3.26.67 5.57 1.46 8.71 6.26s9.25 22.78 10.85 29.08c0 0-4 5.11-14.14 6.06l-10.88-25.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "396.8px 196.174px"
    },
    id: "ell6n7y7rhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b16668",
      transformOrigin: "372.475px 176.41px"
    },
    id: "eldgnnl1s6fw",
    className: "animable",
    d: "m380.09 166.71.04 9.37.24 6.5 1.06 2.67-17.32.86-.59-17.34 16.57-2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.44 184.39c-1.5-5-6.52-8.77-10.84-8.69a35.69 35.69 0 0 0-4.49.56c.21 1.86-.17 3.33-3.19 4.34a16.7 16.7 0 0 1-13-1.71v-1s-4.91.48-7.6 1c-6 1.16-8.72 3.49-15.57 18.49-2.93 6.42-2 15.27 4.62 19.4-1 16.23-1.29 36.68-1.29 36.68s4.45 4.36 25.14 4.83c20.49.46 30.15-8.14 30.15-8.14-.19-4.76-4.84-17.53-10.93-28.24 7.56-17.69 9.22-30.11 7-37.52Z",
    style: {
      fill: "#37474f",
      transformOrigin: "369.27px 217.003px"
    },
    id: "eldhkyi9bojsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6 150.08s-3.48 5.58-3 6.15 2.81 1.12 2.81 1.12Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "350.077px 153.715px"
    },
    id: "elw0vorxh6c2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.92 145s-10.87-6.1-1.65-16.4c6.62-7.4 17-6.18 29.45-1.45 5.81 2.22 12.83 5 12.83 18.5 0 8.91-22.87 16.22-22.48 22.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "371.555px 145.648px"
    },
    id: "el2d1yagko4pi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42 132.81c-3.41 1.76-9.31 5-10.85 17.57-1.57 12.9 1.29 17.38 3.05 19.08 1.19 1.14 7.31 1.56 10.51.58 4-1.24 12.66-5.51 16.73-12.16 4.79-7.83 5.79-18.27.28-22.37-7.75-5.77-16.83-4.19-19.72-2.7Z",
    style: {
      fill: "#b16668",
      transformOrigin: "368.496px 151.005px"
    },
    id: "el3wji88omgrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.66 170.37c-2.9.51-6.86.22-8.57-.6a16.78 16.78 0 0 0 8.31-2.08Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "359.375px 169.157px"
    },
    id: "el92vauq4bjub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.16 148a12.81 12.81 0 0 1-7.92-10.56c-1-8.24 9.31-11.43 9.31-11.43Z",
    style: {
      fill: "#263238",
      transformOrigin: "358.861px 137.005px"
    },
    id: "els9x71fpjvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55 144.1a23.43 23.43 0 0 0-.82-5.26c-1.61-5.31-4-7.78-9.27-9.54-14.06-4.7-23 4-23 4a43.33 43.33 0 0 0-1 12.9 3 3 0 0 0-.91-.08l-.16 5.64a3.1 3.1 0 0 0 3 3.19l.09-3.19c.79-1.25 2.69-3.5 5.61-2.52 2.58.86 3.56 3.57 2.95 6.07a7.17 7.17 0 0 1-2 3.46c-1.47 1.42-2.8 1.4-4.71.72a.59.59 0 0 0-.53.07c-.23.17-.18.53-.1.82A20.22 20.22 0 0 0 366 166a11.12 11.12 0 0 0 4.54 4.28c2 1.07 8.48 1.08 9.85-.41 1.84-2.35 6-6.38 8.25-9.38a23 23 0 0 0 4.63-9.38c.65-2.75 1.34-4.77 1.28-7.01Z",
    style: {
      fill: "#263238",
      transformOrigin: "376.971px 149.474px"
    },
    id: "elk8oiqlmn349",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.89 184.31a15.41 15.41 0 0 1-15.41-15.41v-32a15.41 15.41 0 0 1 15.41 15.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "400.185px 160.605px"
    },
    id: "eljr1i3w6f2xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.24 133.41-4.79 4.43a3.26 3.26 0 0 1 4.79-4.43Z",
    style: {
      fill: "#263238",
      transformOrigin: "395.413px 135.103px"
    },
    id: "elsy1y5t0y7ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24 179.07c-5.56.16-11.78.13-15.39 5-4.56 6.17-21.82 26.42-21.82 26.42s-27.08-9.43-30.56-12.28c-1.57-1.28-1.46-4.52-1.45-6.3s0-4.5.18-5.64c.3-2-2.44-.77-3.45 1.43-1.08 2.35-.9 4.52-1.59 5.26s-6.78-3.43-10.43-6.25-6-5.29-7.24-3.15c-.55.92.57 2.39 3.28 4.89a39.08 39.08 0 0 1 3.52 3.33c.26.35-.13.64.09 1a6.91 6.91 0 0 0-1.53 1 2.35 2.35 0 0 0-.83 1.56c0 .7.34 1.42.11 2.09s-1.17 1.13-1.33 1.89.67 1.57.9 2.42-.13 1.59.05 2.36a3.12 3.12 0 0 0 1.39 1.69c1.91 1.34 3.88 1.63 6.06 2.16 2.47.6 5 .88 7.48 1.45 2.59 1.36 34.43 20.49 39.52 18.1s26-24.81 26-24.81c7.92-8.1 9.8-20.13 7.04-23.62Z",
    style: {
      fill: "#b16668",
      transformOrigin: "310.895px 203.388px"
    },
    id: "elx800ka73li",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.21 179c-3.25-.27-8.15-.18-11 .79s-5.23 1.31-10.42 8.46c-4.44 6.1-15.13 20.26-15.13 20.26a16.56 16.56 0 0 0 12.24 10.9s13.62-12.54 16.3-15.46 5.46-5.53 7.38-11.27a26 26 0 0 0 .63-13.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "339.25px 199.139px"
    },
    id: "elqmg6pr9hwzp",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRequired);
export default __webpack_public_path__ + "static/media/paymentRequired.63d2115c2e761d83cf87cbd924d6f41d.svg";
export { ForwardRef as ReactComponent };